import { useMemo } from 'react';
import './RegionConnectedPage.scss';
import { Timeline } from 'components/Timeline';

const RegionConnectedPage = ({ isOpen, onClose }) => {
  const isMobile = useMemo(() => window.innerWidth <= 1024, []);
  if (!isOpen) return null;

  return (
    <div
      className="region-connected-page"
      style={{
        width: `${
          document.body.classList.contains('menu-open') && !isMobile
            ? 'calc(100vw - 260px)'
            : '100vw'
        }`,
        height: `${isMobile ? 'calc(100dvh - 50px)' : '100dvh'}`,
      }}
    >
      <div className="timeline-wrapper">
        <Timeline />
      </div>
      <div className="map-container">
        <MapSvg />
      </div>
    </div>
  );
};

export default RegionConnectedPage;

const MapSvg = () => {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="100 0 950.08 727.09"
    >
      <defs>
        <clipPath id="clippath">
          <rect
            className="cls-5"
            x="161"
            y="-161"
            width="727.09"
            height="1049.08"
            transform="translate(161 888.08) rotate(-90)"
          />
        </clipPath>
        <clipPath id="clippath-1">
          <path
            className="cls-5"
            d="m491.74,470.35c.4,0,.72.09.94.26.22.17.39.39.51.67.12.28.19.58.22.9.03.32.04.63.04.91v15.05c0,.05,0,.28,0,.86.03,3.4-2.31,4.64-2.31,4.64,0,0,1.22,0,2.3-.27,4.31-1.07,4.33-3.59,4.34-4.37v-15.37c0-.3,0-.65.02-1.03,0-.38.06-.74.16-1.08.1-.34.26-.62.51-.84.24-.22.58-.33,1.03-.33h-7.75Z"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1="1335.48"
          y1="-979.64"
          x2="1430.61"
          y2="-979.64"
          gradientTransform="translate(-847.49 1460.84)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#1773ba" />
          <stop offset=".59" stopColor="#1d2d5b" />
        </linearGradient>
        <clipPath id="clippath-2">
          <path
            className="cls-5"
            d="m572.56,470.36h7.04c-.37,0-.66.09-.88.27-.21.18-.37.4-.48.68-.11.28-.17.57-.19.89-.02.32-.03.62-.03.9v13.41c0,.28.02.57.05.86.04.29.11.56.21.8s.27.43.48.59c.21.15.5.23.85.23h-7.07c.37,0,.66-.08.88-.25.21-.17.37-.38.48-.64.11-.26.17-.54.2-.85.03-.31.04-.61.04-.89v-13.25c0-.28-.01-.59-.04-.9-.03-.32-.09-.62-.2-.89-.11-.27-.27-.5-.48-.68-.21-.18-.5-.27-.88-.27Z"
          />
        </clipPath>
        <clipPath id="clippath-3">
          <path
            className="cls-5"
            d="m568.2,487.9c-1.11-.92-1.4-2.41-1.72-3.17-.32-.76-.69-1.49-1.12-2.18-.43-.69-.92-1.31-1.49-1.85-.57-.54-1.28-.91-2.13-1.1.66-.07,1.28-.22,1.86-.44.58-.22,1.09-.52,1.53-.9.43-.38.77-.84,1.02-1.38.25-.54.37-1.17.37-1.88,0-.8-.16-1.49-.48-2.06-.32-.58-.74-1.06-1.26-1.44-.52-.38-1.12-.67-1.79-.85-.61-.17-1.23-.26-1.86-.28h0s-.21,0-.21,0h-9.02c.34,0,.6.08.8.24.19.16.35.36.45.61.11.25.17.52.2.81.03.29.04.57.04.84v13.39c0,.3,0,.61-.03.93-.02.32-.08.61-.19.88-.11.27-.27.49-.48.67-.21.18-.51.27-.9.27h7.07c-.37,0-.66-.09-.88-.27-.21-.18-.37-.4-.48-.68-.11-.27-.17-.57-.2-.89-.03-.32-.04-.62-.04-.9v-6.53s2.37-.07,3.29.38c.4.19.58.75.78,1.28.2.53.39,1.12.56,1.76.17.64.33,1.26.49,1.88.16.61.33,1.17.52,1.68.19.51.4.88.65,1.13.27.27.56.48.88.64s.65.28,1,.36.7.13,1.06.15c.36.02.72.03,1.08.03h3.06c-.64,0-1.32-.17-2.43-1.09Zm-7.21-8.57c-.34.21-3.71.18-3.71.18v-6.69c0-.06,0-.13,0-.21,0,0,0,0,0,0,0-.12,0-.25.02-.37.09-1.01.55-1.39.73-1.51.81-.46,2.69-.28,3.13-.07.72.6,1.02,1.61,1.15,2.4.05.33.08.66.09,1,.02.54.03.97.03,1.29,0,.53-.02,1.05-.05,1.54-.04.5-.15.94-.33,1.34-.19.4-.67.88-1.04,1.11Z"
          />
        </clipPath>
        <clipPath id="clippath-4">
          <path
            className="cls-5"
            d="m542.82,488.84c-.09.06-.58.11-.67.13h7.33c-.43,0-.8-.13-1.12-.4-.32-.27-.59-.59-.82-.97-.23-.38-.43-.79-.58-1.22-.16-.43-.3-.81-.43-1.13-.96-2.48-1.87-4.96-2.75-7.45-.88-2.49-1.82-4.99-2.83-7.45h-.56c-.3.8-.59,1.61-.88,2.39-.28.78-.57,1.57-.85,2.36l-5.16,12.91c-.16.33-.61.96-1.61.96h1.58l5.37-13.47c.11.27.25.61.41,1.04.27.7.57,1.5.9,2.39.34.89.68,1.84,1.04,2.84.35,1,.68,1.93.97,2.8.29.87.53,1.62.72,2.27.19.65.28,1.07.28,1.26,0,.32-.11.56-.33.72Z"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-2"
          x1="1335.48"
          x2="1430.61"
          gradientTransform="translate(-847.49 1460.84)"
          xlinkHref="#linear-gradient"
        />
        <clipPath id="clippath-5">
          <path
            className="cls-5"
            d="m538.81,480.85c-.01.33-.15,1.73-1.51,1.73,1.36,0,1.5,1.4,1.51,1.73v.07s0,0,0-.02c0,.01,0,.02,0,.02v-.07c.01-.33.15-1.73,1.51-1.73-1.36,0-1.5-1.4-1.51-1.73h0Z"
          />
        </clipPath>
        <clipPath id="clippath-6">
          <path
            className="cls-5"
            d="m507.01,480.85c-.01.33-.15,1.73-1.51,1.73,1.36,0,1.5,1.4,1.51,1.73v.07s0,0,0-.02c0,.01,0,.02,0,.02v-.07c.01-.33.15-1.73,1.51-1.73-1.36,0-1.5-1.4-1.51-1.73h0Z"
          />
        </clipPath>
        <clipPath id="clippath-7">
          <path
            className="cls-5"
            d="m511.03,488.84c-.09.06-.58.11-.67.13h7.33c-.43,0-.8-.13-1.12-.4-.32-.27-.59-.59-.82-.97-.23-.38-.43-.79-.58-1.22-.16-.43-.3-.81-.43-1.13-.96-2.48-1.87-4.96-2.75-7.45-.88-2.49-1.82-4.99-2.83-7.45h-.56c-.3.8-.59,1.61-.88,2.39-.28.78-.57,1.57-.85,2.36l-5.16,12.91c-.16.33-.61.96-1.61.96h1.58l5.35-13.52c.11.27.26.63.43,1.09.27.7.57,1.5.9,2.39.34.89.68,1.84,1.04,2.84.35,1,.68,1.93.97,2.8.29.87.53,1.62.72,2.27.19.65.28,1.07.28,1.26,0,.32-.11.56-.33.72Z"
          />
        </clipPath>
        <clipPath id="clippath-8">
          <path
            className="cls-5"
            d="m531.27,481.03c-.42-.68-.94-1.28-1.57-1.81-.63-.52-1.31-1-2.05-1.42-.74-.42-1.42-.86-2.05-1.3-.63-.44-1.15-.92-1.57-1.43-.42-.51-.62-1.12-.62-1.83,0-.3.04-.61.11-.92.07-.3.17-.59.31-.85.23-.36.7-.83,1.67-.94.16,0,.33,0,.5.01.47.06.89.15,1.26.27.73.26,1.54.72,2.37,1.51,1.56,2.01,1.61,2.69,1.61,2.69v-4.66s-.5,1.4-2.84.65c-.76-.35-1.44-.53-2.06-.61h0s-1.01-.14-1.81.08c0,0-.91.23-1.34.4-.65.25-1.21.59-1.69,1.04-.48.44-.85.97-1.13,1.58-.27.61-.41,1.31-.41,2.08,0,.97.2,1.8.61,2.48.41.68.92,1.28,1.54,1.81.62.52,1.28.99,1.99,1.41.71.42,1.37.85,1.99,1.3.62.45,1.13.96,1.54,1.53.41.57.61,1.26.61,2.07,0,.67-.16,1.27-.49,1.81-.02.03-.05.06-.07.1-.09.11-.21.21-.35.31-.18.1-2.88,1.5-5.9-1.37-1.56-2.01-1.61-2.69-1.61-2.69v4.66s.5-1.4,2.84-.65c1.88.88,3.29.71,4.61.41,0,0,0,0,0,0,.02,0,.04-.01.07-.02.02,0,.04,0,.06-.01.14-.03.25-.06.33-.09.26-.07.51-.15.75-.24.68-.26,1.28-.6,1.78-1.04.5-.43.9-.96,1.2-1.59.29-.63.44-1.39.44-2.27,0-.96-.21-1.77-.62-2.46Z"
          />
        </clipPath>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <path
            className="cls-11"
            d="m889.55,239.03c3.04-2.68,5.68-6.5,8.7-10.89,3.91-5.69,8.34-12.15,14.61-17.22,6.14-4.96,16.93-12.55,26.45-19.24,8.68-6.1,16.18-11.37,18.66-13.6l-3.71-4.13c-2.23,2.01-9.96,7.44-18.13,13.19-9.59,6.74-20.47,14.38-26.75,19.47-6.9,5.58-11.57,12.38-15.69,18.39-3.03,4.42-5.65,8.24-8.4,10.4-.99.78-3.64,2.36-7.42,4.48-4.11-1.45-12.32-4.07-16.13-3.39-1.77.32-4.64,1.8-8.6,3.85-7.27,3.76-18.27,9.45-29.56,11.27-15.77,2.53-37.35.6-56.4-1.11l-5.08-.45c-22.29-1.96-41.17.12-82.47,16.93-40.07,16.31-160.92,80.1-176.11,89.79-1.07-4.06-4.1-19.66-3.85-29.23-.03-4.7,1.93-9.02,5.66-11.98,2.71-2.39,6.11-3.99,8.9-6.45.86-.86,1.55-1.74,2.58-2.43,11.74-7.74,27.16-17.13,26.45-33.18-.19-5.04-2.02-9.72-3.11-14.37-.44-2.3-.84-4.9-1.66-7.17-1.6-4.65-3.81-9.02-5.96-13.41-1.06-2.2-2.16-4.34-2.92-6.64-.43-1.21-1.17-2.3-2.04-3.21-3.13-3.49-9.2-4.71-10.29-9.63-.37-1.74-.14-3.6-.1-5.39-.01-.64.05-1.31-.18-1.92-.29-.67-.85-1.08-1.39-1.4-5-2.53-10.9-1.87-15.79-4.51-2.22-.97-4.38-2.12-6.27-3.63-2.08-1.65-3.57-3.17-2.96-6.03.94-4.77,3.61-9.06,6.26-13.07-2.71,4.01-5.43,8.24-6.43,13.05-.19,1.19-.24,2.51.4,3.63.73,1.02,1.62,1.85,2.57,2.64,2.87,2.32,6.27,3.84,9.69,5.13,4.02,1.33,8.49,1.26,12.26,3.28.79.47,1.31,1.02,1.26,1.95.06,2.15-.38,4.27.05,6.43,1.33,6.37,10.2,7.04,12.16,13,2.66,7.44,7.04,14.19,9.14,21.84,0,0,.41,1.74.41,1.74.44,3.57,1.54,7.25,2.44,10.71,3.83,13.14-2.66,22.88-12.97,30.54-3.89,2.98-8.09,5.29-12.14,8.12-1.02.66-1.91,1.67-2.76,2.53-4.75,3.78-11.03,6.34-13.79,12.24-1.18,2.3-1.55,4.97-1.7,7.5-.26,4.99.13,9.9.62,14.78.99,9.62.13,9.1,2.39,14.78l.05,2.87c-5.41,2.45-26,11.78-26,11.78l-6.82,3.09c-.35.15-.68.33-1.03.5-.32-5.05-.89-10.06-2.05-15-1.89-7.07-3.05-9.78-10.98-9.49-4.26-.18-12.24,1.67-15.04-2.15-2.89-4.49-6.28-8.6-9.69-12.67,3.33,4.14,6.63,8.33,9.4,12.85,1.56,2.42,4.77,2.59,7.35,2.73,3.98.15,7.96-.41,11.88.22,4.28.39,5.19,5.28,6.07,8.74,1.07,5.05,1.52,10.26,1.72,15.42-5.98,3.11-11.25,7.66-15.16,13.13-2.22,3.04-4.52,6.11-6.17,9.54-.6,1.12-1.03,2.6-1.03,3.82-.28,5.05-.2,10.02-.34,15.01-.34,5.07-.23,9.98.51,15,.4,4.91-.1,9.9-1.44,14.65-1.48,4.95-4.72,16.82-6.3,21.55-2.25,6.95-7.52,13.05-11.99,18.72-6.26,7.74-18.27,15.71-25.43,22.64-.9.77-1.84,1.73-2.98,2.06-3.62,1.08-5.96,2.88-9.36,4.48-7.83,3.89-10.69,7.94-18.24,12.34-.74.49-1.93,1.1-2.71,1.73.35-.27.75-.5,1.12-.74l1.61-.96c7.59-4.33,10.48-8.32,18.34-12.15,2.25-1.08,3.53-2.14,5.83-3.11,1.15-.47,2.31-.97,3.49-1.26,1.28-.36,2.18-1.3,3.16-2.11,7.26-6.91,19.31-14.81,25.66-22.53,2.7-3.52,6.86-8.15,9.03-12.01,2.63-4.31,4.09-9.2,5.46-14l4.26-14.37c1.41-4.85,1.96-9.96,1.6-15-.19-2.51-.64-4.93-.65-7.43-.07-2.49.21-4.97.26-7.45.29-5.54-.04-11.2.69-16.64,1.55-4.01,4.26-7.45,6.8-10.9,2.91-3.98,6.49-7.43,10.58-10.14,3.62-2.51,9.22-4.71,13.3-6.55,0,0,18.98-8.41,25.34-11.23l.16,9.5-2.76,11.19-.07.23-.43.84-76.75,161.43c-13.91,4.74-30.69,6.32-30.92,6.34l-.44.04-20.47,8.84-31.53,7.13c-.34.08-.67.19-.99.34l-32.25,15.24c-1.36-2.92-3.44-7.37-3.44-7.37-1.38-3.7-4.62-6.18-7.51-8.61-5.72-4.65-11.7-8.83-17.34-13.38-2.85-2.47-6.38-4.9-8.05-8.27-.62-1.99-.6-3.81.62-5.63,1.05-1.61,1.57-3.94,1.33-5.88-.21-4.73-4.25-8.3-4.96-12.72-.56-3.6,1.95-6.3,3.53-9.47.83-1.69,1.53-3.44,2.08-5.24,1.12-3.59,1.56-7.32,2.01-10.91.21-1.87.7-3.69.6-5.58-.66-9.19-3.68-17.96-5.07-27-.64-3.57-.72-7.09-.19-10.67,1.32-9.8,7.1-18.75-5.73-23.21-1.24-.49-2.54-.63-3.62-1.34-3.42-3.26-6.66-12.76-11.73-13.28-.47-.02-1.05.19-1.49.32-2.93.89-6.18-5.66-9.09-6.69-1.73-.53-3.11-1.69-4.54-2.74-1.55-1.06-3.21-1.89-4.89-2.64-5.07-2.2-10.39-3.67-15.8-4.72-5.37-1.12-9.22-5.5-12.5-9.66-4.4-5.79-8.15-12.09-11.94-18.29-5.63-9.43-7.78-20.4-10.05-31.02-.74-3.57-1.69-7.11-2.55-10.65-1.49-7.12-1.41-14.62.47-21.67-1.94,7.04-2.08,14.55-.64,21.71.84,3.56,1.75,7.08,2.47,10.66,2.19,10.7,4.25,21.68,9.85,31.23,3.77,6.27,7.45,12.58,11.84,18.45,3.31,4.28,7.32,8.86,12.89,10.04,5.32,1.08,10.61,2.58,15.57,4.78,2.54,1.06,4.76,2.58,6.92,4.23,3.6,2.4,8.27,9.26,12.3,8.04l.66-.2c.16-.05.33-.08.5-.07,1.58.11,2.87,1.69,3.86,2.9,2.26,2.87,3.86,6.13,6.05,9.11.57.8,1.41,1.59,2.41,1.84,0,0,2.6.86,2.6.86,7.63,2.32,7.41,7.32,6.05,13.98-.92,5.36-1.89,7.81-1.83,13.36.37,11.39,5.16,22.26,5.33,33.62-.79,4.85-1.16,9.96-2.62,14.58-1.06,3.59-2.81,6.37-4.73,9.67-.87,1.76-1.35,3.86-1.07,5.9.28,2.04,1.15,3.84,2.03,5.47,2.11,3.62,4.22,7.83,1.73,11.72-.45.76-1.01,1.73-1.22,2.83-.34,2.14-.03,4.31,1.08,6.13,2.23,3.24,5.11,5.48,8.02,7.95,5.69,4.66,11.65,8.9,17.22,13.51,2.22,1.98,4.78,3.79,6.13,6.44.24.52,2.53,5.53,3.99,8.72l-37.9,17.91c-11.31,3.69-25.02,8.28-26.46,9.24-1.43.84-16.15,7.21-25.1,11.02l-.4.21c-1.88,1.19-18.21,11.59-20.59,13.33-2.43,1.33-25.03,9.06-38.8,13.65l1.76,5.27c14.16-4.72,38.23-12.87,40.28-14.41,1.39-1.04,12.72-8.31,20.13-13.02,7.26-3.1,23.57-10.09,25.64-11.32,1.53-.78,14.22-5.08,25.42-8.74l.17-.05,69.96-34.83c2.16-1.07,4.47-1.82,6.84-2.21l27.77-4.56.25-.06,8.01-3.46c-.66,6.9-2.57,28.11-2.36,41.29.21,13.28,11.12,24.87,19.09,33.34,1.76,1.87,3.42,3.64,4.78,5.22,4.99,5.82,6.04,12.08,7.05,18.14.49,2.96.96,5.75,1.86,8.45.6,1.81,1,3.64,1.43,5.59,1.5,6.85,3.04,13.94,13.55,19.69,0,0-12.89-10.37-12.59-19.9.06-1.93-.84-3.83-1.46-5.69-.88-2.63-1.34-5.38-1.82-8.3-1.03-6.19-2.1-12.58-7.27-18.61-1.37-1.6-3.04-3.38-4.81-5.25-7.86-8.35-16.53-20.78-16.73-33.67-.21-13.5,2.82-35.82,3.43-42.07l8-3.45c4.23-.42,34.46-3.75,47.29-14.6,2.4-2.03,5.35-4.13,8.76-6.55,14.3-10.17,35.91-25.53,49.54-61.07,14.19-37,26.74-68.32,36.53-76.9,1.39-1.21,4.61-3.67,9.23-7.01-.41,2.97-.74,5.95-.97,8.95-.15,4.62-.9,9.51,1.12,13.88.04.07.1.13.14.2-.07.03-.12.05-.12.05.64,1.68.94,3.68.95,5.57.02,3.96-1.39,7.56-3.52,10.9,0,0-3.06,5.18-3.06,5.18l-12.25,20.72c-2.77,12.14-6.41,24.32-12.43,35.3l-1.58,2.67s-1.74,2.57-1.74,2.57c-10.67,15.46-18.06,32.91-25.51,50.07,6.71-15.22,13.65-30.45,22.49-44.57,1.6-2.54,3.64-5.22,5.32-7.72,2.79-4.4,5.1-9.19,7.05-14,3.04-7.47,5.82-16.55,7.36-23.76l12.48-20.59s3.12-5.15,3.12-5.15c3.12-4.58,4.69-10.37,3.43-15.88.39.14.79.25,1.18.34,3.25.72,6.93.33,9.85,1.81,4.17,2.28,3.67,7.55,3.9,11.7.07,21.04,5.99,37.25,29.74,38.1,7.29-1.87,15.15-3.02,22.56-1.14,4.59,1.19,10.12,4.63,9.37,10.05-1.31,7.68-8.7,12.48-11.25,19.62,2.65-7.16,10.09-11.85,11.48-19.59.77-8.65-10.26-11.43-17.08-11.47-4.95-.09-10.63.7-15.05,1.93-4.5-.22-9.02-1.02-13.13-2.85-13.59-5.88-15.52-21.55-15.51-34.69.07-9.02-1.2-13.84-11.29-14.34-1.7-.26-4.02-.22-5.33-1.41,0-.02-.01-.05-.02-.07,0,0-.02,0-.03.01-.11-.11-.23-.21-.33-.34-.46-.82-.7-1.91-.85-2.99-.64-6.81.3-13.7,1.36-20.46,26.79-19.19,92.66-62.77,131.15-75.6,25.11-8.37,52.58-11,74.66-13.11,18.88-1.81,33.79-3.24,40.92-7.66,6.65-4.12,27.1-14.9,46.88-25.33,17.43-9.19,34.17-18.01,43.71-23.41.54-.18,1.08-.36,1.62-.54,29.66-9.56,72.84-8.2,73.27-8.18l.1-2.77c-.4-.01-37.25-1.18-66.6,6.15Zm-398.5,233.72c-13.03,33.97-33,48.17-47.58,58.53-3.51,2.5-6.54,4.65-9.12,6.84-2.59,2.19-6.1,4.05-10,5.63l47.81-100.56,25.71,12c-2.16,5.48-4.42,11.32-6.82,17.56Zm7.84-20.15l-25.53-11.92,26.02-54.72,29.01,8.38c-8.07,7.69-16.81,26.24-29.49,58.26Zm335.98-189.73c-20.78,10.95-40.4,21.3-47.22,25.52-6.02,3.74-21.08,5.18-38.52,6.85-22.36,2.14-50.18,4.8-75.88,13.37-45,15-126.8,71.34-142.33,83.56l-30.29-8.75,3.58-6.96c.49-.96.78-2.02.84-3.1l-.22-12.57c7.84-5.02,134.55-74.46,175.82-91.26,41.02-16.7,58.87-18.7,81.18-16.74l5.08.45c19.21,1.72,40.99,3.67,57.09,1.08,11.73-1.89,22.96-7.7,30.39-11.54,3.46-1.79,6.45-3.34,7.81-3.58,2.45-.43,8.01,1.07,12.36,2.49-10.09,5.57-25.5,13.69-39.7,21.17Z"
          />
          <path
            className="cls-11"
            d="m364.61,530.52s-.05.03-.07.05c.02-.02.05-.04.07-.05Z"
          />
          <path
            className="cls-11"
            d="m364.54,530.57c-.12.1-.23.2-.33.3.1-.11.21-.21.33-.3Z"
          />
        </g>
        <g>
          <path
            className="cls-4"
            d="m672.2,263.8l-.53,16.92c-.22,7.08-4.17,13.5-10.39,16.9l-13.09,7.15c-6.67,3.64-10.7,10.74-10.41,18.33l13.09,348.2"
          />
          <path
            className="cls-4"
            d="m501.01,218.51l114.38,7.72c6.78.46,13.6-.13,20.2-1.74l227.35-55.56"
          />
          <circle className="cls-15" cx="499.78" cy="219.68" r="5.51" />
          <line
            className="cls-4"
            x1="432.16"
            y1="201.14"
            x2="498.83"
            y2="219.41"
          />
          <line
            className="cls-4"
            x1="463.01"
            y1="172.15"
            x2="499.78"
            y2="219.68"
          />
          <path
            className="cls-4"
            d="m497.48,222.26l-156.99,128.85-16.32,33.02c-3.82,8.23-13.59,19.69-21.04,24.86l-55.9,40.63"
          />
          <path
            className="cls-4"
            d="m176.41,197.93l10.14,31.86c4.23,13.28,9.82,26.09,16.68,38.23l51.95,94.03-31.5,330.48"
          />
          <path
            className="cls-4"
            d="m255.18,362.05l89.16,198.07,57.57-14.79c11.02-2.72,20.23-10.27,25.04-20.55l64.4-137.42c2.52-5.37,2.17-11.66-.93-16.72l-9.34-8.76"
          />
          <path
            className="cls-4"
            d="m349.56,558.77l34.71-180.48c1.08-6.28,8.45-20.67,18.89-30.71,10.55-10.15,11.6-10.8,13.33-26.95,3.76-35.08,6.45-140.63,6.45-140.63"
          />
          <path
            className="cls-4"
            d="m502.14,222.26l-10.2,103.45c-.51,5.16-.38,10.37.39,15.5l1.99,13.32"
          />
          <path
            className="cls-4"
            d="m649.87,644.51l-261.7-74.06,4.56-9.67s44.23,4.21,74.85-35.66c30.62-39.87,42.12-72.93,48.62-86.46,6.5-13.53,6.35-34.73,45.99-58.2,47.29-28,87.96-60,152.75-72.19,33.13-6.24,54.95,3.03,98.86-22.47,36.58-21.24,65.33-38.66,91.66-42.66"
          />
          <line
            className="cls-4"
            x1="340.49"
            y1="351.11"
            x2="305.15"
            y2="196.51"
          />
          <path
            className="cls-2"
            d="m243.55,484.03l396.41-203.77s50.84-32.44,107.66-35.33c19.98-1.02,55,7.83,80.99,1.33,12.56-3.14,20.14-11.24,30.5-13.37,5.77-1.19,14.07,1.99,23.44-3.09,4.55-2.47,14.74-19.08,24.06-27.53,9.29-8.43,45.66-33.33,45.66-33.33"
          />
          <path
            className="cls-2"
            d="m198.68,661.69l222.93-9.93c14.28-.64,27.85-6.37,38.25-16.18,52.78-49.75,221.01-205.86,276.24-227.02,47.9-18.35,201.73-18.75,201.73-18.75"
          />
          <line
            className="cls-4"
            x1="436.37"
            y1="504.67"
            x2="364.21"
            y2="489.81"
          />
        </g>
        <g>
          <text
            className="cls-34"
            transform="translate(544.57 574.49) rotate(-42.31) scale(.98 1)"
          >
            <tspan x="0" y="0">
              NGUYỄN{' '}
            </tspan>
            <tspan className="cls-51" x="35.34" y="0">
              V
            </tspan>
            <tspan x="39.96" y="0">
              ĂN LINH
            </tspan>
          </text>
          <text
            className="cls-27"
            transform="translate(778.93 392.23) rotate(-4) scale(.98 1)"
          >
            <tspan x="0" y="0">
              NGUYỄN{' '}
            </tspan>
            <tspan className="cls-66" x="35.34" y="0">
              V
            </tspan>
            <tspan x="39.96" y="0">
              ĂN LINH
            </tspan>
          </text>
          <text
            className="cls-25"
            transform="translate(507.5 615.12) rotate(15.24) scale(.98 1)"
          >
            <tspan x="0" y="0">
              TRỊNH{' '}
            </tspan>
            <tspan className="cls-8" x="26.01" y="0">
              V
            </tspan>
            <tspan className="cls-53" x="30.63" y="0">
              ĂN NGHỊ
            </tspan>
          </text>
          <text
            className="cls-22"
            transform="translate(228.41 597.86) rotate(-84.58) scale(.98 1)"
          >
            <tspan x="0" y="0">
              QUỐC LỘ 1A
            </tspan>
          </text>
          <text
            className="cls-26"
            transform="translate(638.77 444.88) rotate(-92.56) scale(.98 1)"
          >
            <tspan x="0" y="0">
              QUỐC LỘ 50
            </tspan>
          </text>
          <text
            className="cls-38"
            transform="translate(228.68 304.55) rotate(59.86) scale(.98 1)"
          >
            <tspan x="0" y="0">
              QUỐC LỘ 1A
            </tspan>
          </text>
          <text
            className="cls-19"
            transform="translate(300.16 483.46) rotate(66.59) scale(.98 1)"
          >
            <tspan x="0" y="0">
              HỒ HỌC LÃM
            </tspan>
          </text>
          <text
            className="cls-37"
            transform="translate(354.61 518.27) rotate(-79.8) scale(.98 1)"
          >
            <tspan x="0" y="0">
              AN D
            </tspan>
            <tspan className="cls-50" x="19.57" y="0">
              Ư
            </tspan>
            <tspan className="cls-16" x="25.2" y="0">
              ƠNG V
            </tspan>
            <tspan className="cls-60" x="50.74" y="0">
              Ư
            </tspan>
            <tspan x="56.36" y="0">
              ƠNG
            </tspan>
          </text>
          <text
            className="cls-24"
            transform="translate(416.86 267.38) rotate(-88.03) scale(.98 1)"
          >
            <tspan x="0" y="0">
              AN D
            </tspan>
            <tspan className="cls-42" x="18.24" y="0">
              Ư
            </tspan>
            <tspan className="cls-59" x="23.49" y="0">
              ƠNG V
            </tspan>
            <tspan className="cls-42" x="47.3" y="0">
              Ư
            </tspan>
            <tspan x="52.54" y="0">
              ƠNG
            </tspan>
          </text>
          <text
            className="cls-23"
            transform="translate(325.76 303.15) rotate(-102.06) scale(.98 1)"
          >
            <tspan x="0" y="0">
              TÊN L
            </tspan>
            <tspan className="cls-49" x="22.26" y="0">
              Ử
            </tspan>
            <tspan x="27.62" y="0">
              A
            </tspan>
          </text>
          <text
            className="cls-30"
            transform="translate(351.25 337.28) rotate(-38.99) scale(.98 1)"
          >
            <tspan x="0" y="0">
              KINH D
            </tspan>
            <tspan className="cls-52" x="25.18" y="0">
              Ư
            </tspan>
            <tspan className="cls-54" x="30.42" y="0">
              ƠNG V
            </tspan>
            <tspan className="cls-52" x="54.23" y="0">
              Ư
            </tspan>
            <tspan x="59.48" y="0">
              ƠNG
            </tspan>
          </text>
          <text
            className="cls-18"
            transform="translate(541.91 324.15) rotate(-27.57) scale(.98 1)"
          >
            <tspan x="0" y="0">
              VÕ{' '}
            </tspan>
            <tspan className="cls-7" x="13.02" y="0">
              V
            </tspan>
            <tspan x="17.33" y="0">
              ĂN KIỆT
            </tspan>
          </text>
          <text
            className="cls-20"
            transform="translate(645.28 219.04) rotate(-14.35) scale(.98 1)"
          >
            <tspan x="0" y="0">
              HỒNG BÀNG
            </tspan>
          </text>
          <text
            className="cls-35"
            transform="translate(320.46 437.26) rotate(-26.9) scale(.98 1)"
          >
            <tspan x="0" y="0">
              VÕ{' '}
            </tspan>
            <tspan className="cls-6" x="13.02" y="0">
              V
            </tspan>
            <tspan x="17.33" y="0">
              ĂN KIỆT
            </tspan>
          </text>
          <text
            className="cls-29"
            transform="translate(466.12 433.18) rotate(-64.96) scale(.98 1)"
          >
            <tspan x="0" y="0">
              PHÚ ĐỊNH
            </tspan>
          </text>
          <text
            className="cls-36"
            transform="translate(369.38 487.61) rotate(10.97) scale(.98 1)"
          >
            <tspan className="cls-58" x="0" y="0">
              TR
            </tspan>
            <tspan className="cls-63" x="8.78" y="0">
              Ư
            </tspan>
            <tspan className="cls-58" x="13.71" y="0">
              ƠNG ĐÌNH HỘI
            </tspan>
          </text>
          <text
            className="cls-21"
            transform="translate(504.08 304.39) rotate(-84.57) scale(.98 1)"
          >
            <tspan className="cls-65" x="0" y="0">
              NGUYỄN{' '}
            </tspan>
            <tspan className="cls-40" x="34.06" y="0">
              V
            </tspan>
            <tspan className="cls-65" x="38.49" y="0">
              ĂN{' '}
            </tspan>
            <tspan className="cls-1" x="51.76" y="0">
              L
            </tspan>
            <tspan className="cls-65" x="55.98" y="0">
              UÔNG
            </tspan>
          </text>
          <g>
            <text
              className="cls-28"
              transform="translate(656.7 338.91) rotate(-26.13) scale(.98 1)"
            >
              <tspan x="0" y="0">
                P
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(660.7 336.94) rotate(-24.58) scale(.98 1)"
            >
              <tspan x="0" y="0">
                H
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(665.31 334.83) rotate(-23.02) scale(.98 1)"
            >
              <tspan x="0" y="0">
                Ạ
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(670.15 332.77) rotate(-21.45) scale(.98 1)"
            >
              <tspan x="0" y="0">
                M
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(675.56 330.66) rotate(-20.37) scale(.98 1)"
            >
              <tspan x="0" y="0">
                {' '}
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(677.42 329.96) rotate(-19.52) scale(.98 1)"
            >
              <tspan x="0" y="0">
                T
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(681.5 328.51) rotate(-18.27) scale(.98 1)"
            >
              <tspan x="0" y="0">
                H
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(686.35 326.91) rotate(-17.02) scale(.98 1)"
            >
              <tspan x="0" y="0">
                Ế
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(690.64 325.61) rotate(-16.19) scale(.98 1)"
            >
              <tspan x="0" y="0">
                {' '}
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(692.54 325.05) rotate(-15.29) scale(.98 1)"
            >
              <tspan x="0" y="0">
                H
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(697.45 323.71) rotate(-14.38) scale(.98 1)"
            >
              <tspan x="0" y="0">
                I
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(699.49 323.18) rotate(-13.55) scale(.98 1)"
            >
              <tspan x="0" y="0">
                Ể
              </tspan>
            </text>
            <text
              className="cls-28"
              transform="translate(703.86 322.13) rotate(-12.33) scale(.98 1)"
            >
              <tspan x="0" y="0">
                N
              </tspan>
            </text>
          </g>
        </g>
        <g>
          <text className="cls-17" transform="translate(772.38 360.23)">
            <tspan x="0" y="0">
              QUẬN 7
            </tspan>
          </text>
          <text className="cls-17" transform="translate(569.88 411.88)">
            <tspan x="0" y="0">
              QUẬN 8
            </tspan>
          </text>
          <text className="cls-17" transform="translate(565.41 258.59)">
            <tspan x="0" y="0">
              QUẬN 5
            </tspan>
          </text>
          <text className="cls-17" transform="translate(484.79 172.15)">
            <tspan x="0" y="0">
              QUẬN 11
            </tspan>
          </text>
          <text className="cls-17" transform="translate(405.59 367.53)">
            <tspan x="0" y="0">
              QUẬN 6
            </tspan>
          </text>
          <g>
            <path
              className="cls-10"
              d="m235.08,204.53l-.9-.81c-.7.46-1.52.71-2.44.71-2.54,0-4.36-1.89-4.36-4.23v-.02c0-2.34,1.84-4.25,4.38-4.25s4.36,1.89,4.36,4.23v.02c0,.88-.27,1.67-.73,2.36l.85.72-1.15,1.28Zm-2.24-2l-1.34-1.14,1.15-1.29,1.35,1.22c.15-.34.22-.72.22-1.13v-.02c0-1.41-1.03-2.58-2.49-2.58s-2.47,1.15-2.47,2.56v.02c0,1.41,1.03,2.58,2.49,2.58.41,0,.78-.07,1.08-.22Z"
            />
            <path
              className="cls-10"
              d="m237.59,200.76v-4.7h1.81v4.65c0,1.35.66,2.03,1.77,2.03s1.77-.66,1.77-1.97v-4.71h1.81v4.64c0,2.49-1.4,3.71-3.61,3.71s-3.56-1.22-3.56-3.65Z"
            />
            <path
              className="cls-10"
              d="m249.42,196h1.67l3.52,8.28h-1.89l-.75-1.84h-3.48l-.75,1.84h-1.84l3.52-8.28Zm-.01-2.49h1.69l1.45,1.84h-1.37l-.93-.78-.93.78h-1.35l1.44-1.84Zm1.92,7.33l-1.09-2.67-1.09,2.67h2.19Zm-2,4.23h1.68v1.55h-1.68v-1.55Z"
            />
            <path
              className="cls-10"
              d="m255.89,196.06h1.67l3.85,5.06v-5.06h1.79v8.22h-1.54l-3.98-5.23v5.23h-1.79v-8.22Z"
            />
            <path
              className="cls-10"
              d="m216.81,210.16h3.82c.95,0,1.67.25,2.15.73.38.38.56.85.56,1.4v.02c0,.92-.49,1.47-1.08,1.77.95.36,1.54.93,1.54,2.02v.02c0,1.5-1.22,2.26-3.08,2.26h-3.91v-8.22Zm3.43,3.33c.8,0,1.3-.26,1.3-.87v-.02c0-.55-.42-.85-1.19-.85h-1.79v1.74h1.67Zm.48,3.31c.8,0,1.28-.28,1.28-.89v-.02c0-.55-.4-.89-1.34-.89h-2.09v1.81h2.15Z"
            />
            <path
              className="cls-10"
              d="m224.33,208.1l1.54-.67,1.3,2.08h-1.32l-1.53-1.41Zm1.05,2.06h1.81v8.22h-1.81v-8.22Z"
            />
            <path
              className="cls-10"
              d="m229.24,210.16h1.67l3.85,5.06v-5.06h1.79v8.22h-1.54l-3.98-5.23v5.23h-1.79v-8.22Z"
            />
            <path
              className="cls-10"
              d="m238.52,210.16h1.81v3.25h3.34v-3.25h1.81v8.22h-1.81v-3.3h-3.34v3.3h-1.81v-8.22Z"
            />
            <path
              className="cls-10"
              d="m252.89,211.82h-2.5v-1.67h6.81v1.67h-2.5v6.56h-1.81v-6.56Z"
            />
            <path
              className="cls-10"
              d="m260.35,210.1h1.67l3.52,8.28h-1.89l-.75-1.84h-3.48l-.75,1.84h-1.84l3.52-8.28Zm-.01-2.49h1.69l1.45,1.84h-1.37l-.93-.78-.93.78h-1.35l1.45-1.84Zm1.92,7.33l-1.09-2.67-1.09,2.67h2.19Z"
            />
            <path
              className="cls-10"
              d="m266.81,210.16h1.67l3.85,5.06v-5.06h1.79v8.22h-1.54l-3.98-5.23v5.23h-1.79v-8.22Z"
            />
          </g>
          <text className="cls-17" transform="translate(876.49 180.02)">
            <tspan x="0" y="0">
              QUẬN 1
            </tspan>
          </text>
        </g>
        <g>
          <g>
            <polygon
              className="cls-15"
              points="707.96 167.65 704.58 167.65 704.58 164.27 701.8 164.27 701.8 167.65 698.41 167.65 698.41 170.43 701.8 170.43 701.8 173.82 704.58 173.82 704.58 170.43 707.96 170.43 707.96 167.65"
            />
            <g>
              <path
                className="cls-15"
                d="m689.49,177.93h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m693.03,177.93h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m696.31,177.93h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m700.19,177.93h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m705.09,177.93h.67l1.03,2.64,1.03-2.64h.65l-1.42,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m709.09,177.93h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m710.61,177.93h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m713.9,177.93h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m691.8,185.54h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m695.56,183.81h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m699.14,185.54h0c0-.97.74-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43,2.03h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m704.93,183.81h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m709.69,183.79h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm-.57-1.26c.09-.35.23-.55.5-.55.25,0,.51.17.67.17.13,0,.18-.07.25-.21l.3.09c-.1.35-.23.55-.5.55-.25,0-.5-.17-.66-.17-.13,0-.19.07-.25.22l-.3-.09Zm.57.25h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m712.81,185.89l-1.36-2.08h.71l.96,1.52.97-1.52h.69l-1.36,2.06v1.37h-.61v-1.35Z"
              />
            </g>
          </g>
          <g>
            <polygon
              className="cls-15"
              points="912.41 346.73 909.03 346.73 909.03 343.35 906.24 343.35 906.24 346.73 902.86 346.73 902.86 349.51 906.24 349.51 906.24 352.9 909.03 352.9 909.03 349.51 912.41 349.51 912.41 346.73"
            />
            <g>
              <path
                className="cls-15"
                d="m893.94,357.01h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m897.48,357.01h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m900.76,357.01h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m904.63,357.01h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m909.54,357.01h.67l1.03,2.64,1.03-2.64h.65l-1.42,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m913.54,357.01h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m915.06,357.01h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m918.34,357.01h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m904.63,362.89h2.55v.55h-1.95v.94h1.73v.55h-1.73v1.4h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m907.55,362.89h.67l1.03,2.64,1.03-2.64h.65l-1.42,3.45h-.53l-1.43-3.45Z"
              />
            </g>
          </g>
          <g>
            <text className="cls-33" transform="translate(805.4 435.91)">
              <tspan x="0" y="0">
                ĐẠI HỌC RMIT
              </tspan>
            </text>
            <g>
              <path
                className="cls-15"
                d="m823.41,421.14c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m827.29,425.95v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m828.51,426.24c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m841.04,318.63h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.75,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m846.09,316.63h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Zm-.9,1.69h.55v.61h-.55v-.61Z"
              />
              <path className="cls-15" d="m848.78,316.65h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m851.77,316.65h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m855.35,318.38h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43,2.03h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m859.51,318.38h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m830.82,323.1h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m833.01,324.26h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m837.32,322.54h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m842.81,324.51h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.75,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m846.59,324.51v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.46c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m850.47,324.26h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m856.55,323.1h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m858.88,322.54h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m863.82,322.51h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm-.56-1h.41c.06.18.18.3.43.3s.37-.12.43-.3h.41c-.04.45-.37.71-.84.71s-.8-.26-.84-.71Zm1.42,3.1l-.59-1.37-.59,1.37h1.18Zm-.36-3.9l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m866.48,322.54h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m870.2,324.26h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m851.46,305.32c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m855.34,310.13v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m856.56,310.42c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m386.52,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m388.68,417.19h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m392,419.16v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.47c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m395.48,418.91h0c0-.97.74-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.76-2.62l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m399.63,417.19h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m403.18,418.91h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m408.3,417.19h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m412.24,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m414.41,417.19h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m418.11,417.19h.6v1.72l1.63-1.72h.74l-1.42,1.47,1.49,1.95h-.73l-1.17-1.54-.53.55v.99h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m423.63,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m426.63,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m429.64,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m432.64,417.75h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m388.22,423.07h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m391.77,424.79h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m395.54,425.04v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m400.14,425.15l-1.36-2.08h.71l.96,1.52.97-1.52h.69l-1.36,2.06v1.37h-.61v-1.35Z"
              />
              <path
                className="cls-15"
                d="m402.47,423.07h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm.43-1.25c.09-.35.23-.55.5-.55.25,0,.51.17.67.17.13,0,.18-.07.25-.21l.3.09c-.1.35-.23.55-.5.55-.25,0-.5-.17-.66-.17-.13,0-.19.07-.25.22l-.3-.09Zm.57.25h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m405.58,423.07h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m411.42,423.63h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m413.58,423.07h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m417.17,423.07h.6v3.43h-.6v-3.43Zm.03,3.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m419.97,425.04h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.74,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m423.66,423.07h.6v3.43h-.6v-3.43Zm.03,3.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m425.01,423.07h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m428.71,423.07h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m409.7,405.85c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m413.58,410.66v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m414.8,410.95c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m590.31,554.62h.6v2.88h1.8v.55h-2.41v-3.43Z"
              />
              <path
                className="cls-15"
                d="m594.39,554.6h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm-.49-.87l.54-.24.51.8h-.45l-.6-.56Zm1.36,2.96l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m596.87,554.62h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m600.42,556.35h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m605.69,556.6h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.75,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m610.57,554.6h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Zm-.9,1.69h.55v.61h-.55v-.61Z"
              />
              <path className="cls-15" d="m613.09,554.62h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m615.74,554.62h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m619.14,556.35h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43,2.03h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m623.13,556.35h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m596.46,560.51h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m600.39,562.23h0c0-.97.74-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.32-2.45c.19-.02.31-.08.31-.26,0-.04-.04-.12-.15-.12-.06,0-.15.04-.21.18l-.32-.15c.15-.33.39-.4.54-.4.29,0,.52.21.52.48s-.19.42-.37.48l-.02.19h-.26l-.03-.41Z"
              />
              <path
                className="cls-15"
                d="m605.84,560.51h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m609.06,562.23h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.81h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m613.21,560.51h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m616.75,562.23h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m607.98,543.29c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m611.86,548.1v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m613.08,548.39c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m408.54,477.36h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m410.7,476.81h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m414.02,478.78v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.46c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m417.5,478.53h0c0-.97.75-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.76-2.62l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m421.64,476.81h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m425.19,478.53h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m431.16,477.36h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m433.32,476.81h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m436.72,478.53h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m440.09,479.73l.36-.43c.33.29.65.45,1.08.45.37,0,.61-.17.61-.43h0c0-.25-.14-.39-.77-.53-.73-.17-1.14-.4-1.14-1.02h0c0-.6.49-1,1.17-1,.5,0,.89.15,1.24.43l-.32.46c-.31-.23-.62-.35-.93-.35-.35,0-.56.18-.56.41h0c0,.28.16.39.81.55.73.19,1.1.43,1.1,1h0c0,.66-.5,1.03-1.22,1.03-.53,0-1.02-.18-1.43-.55Z"
              />
              <path
                className="cls-15"
                d="m411.25,482.69h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m414.19,481.84l.54-.24.51.8h-.45l-.6-.56Zm.46.84h.6v3.43h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m416,482.69h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m419.7,482.69h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m424.7,484.66h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.75,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m428.21,484.41h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m432.36,482.69h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m435.9,484.41h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m424.95,465.47c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m428.83,470.28v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m430.05,470.57c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m376.16,456.17h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m378.32,455.61h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m381.64,457.58v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.46c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m385.12,457.33h0c0-.97.75-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.76-2.62l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m389.27,455.61h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m392.81,457.33h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m398.78,456.17h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path className="cls-15" d="m400.97,455.61h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m402.32,455.61h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.96-.1c.19-.02.31-.08.31-.26,0-.04-.04-.12-.15-.12-.06,0-.15.04-.21.18l-.32-.15c.15-.33.39-.4.54-.4.29,0,.52.21.52.48s-.19.42-.37.48l-.02.19h-.26l-.03-.41Z"
              />
              <path
                className="cls-15"
                d="m405.38,457.58v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m410.27,455.61h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m413.68,457.33h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43,2.03h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m417.67,457.33h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m373.97,461.49h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m377.52,463.22h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m381.29,463.47v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m385.89,463.57l-1.36-2.08h.71l.96,1.52.97-1.52h.69l-1.36,2.06v1.37h-.61v-1.35Z"
              />
              <path
                className="cls-15"
                d="m388.22,461.49h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm.43-1.25c.09-.35.22-.55.5-.55.25,0,.51.17.67.17.13,0,.18-.07.25-.21l.3.09c-.1.35-.23.55-.5.55-.25,0-.5-.17-.66-.17-.13,0-.19.07-.25.22l-.3-.09Zm.57.25h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m391.33,461.49h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m396.18,463.22h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.47,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m399.62,463.22h0c0-.97.75-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.44-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m403.77,461.49h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m407.32,463.22h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m413.28,462.05h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m415.44,461.49h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m418.76,463.47v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.47c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m397.75,444.27c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m401.63,449.08v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m402.85,449.37c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m412.66,442.98h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m414.82,442.42h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m418.14,444.4v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.46c.09-.03.13-.07.13-.13,0-.07-.02-.23-.13-.44h.58c.08.22.07.48.07.52,0,.29-.18.48-.52.56v1.43c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m421.62,444.15h0c0-.97.75-1.78,1.8-1.78.4,0,.74.11,1.03.31.13-.03.2-.09.2-.16,0-.07-.02-.24-.13-.44h.58c.08.22.07.48.07.52,0,.22-.11.38-.3.48.21.29.33.65.33,1.04h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.76-2.62l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m425.77,442.42h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m429.31,444.15h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m434.44,442.42h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m439.73,442.4h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm0-1.01h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Zm-.4-3.48l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m442.22,442.42h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m447.6,442.42h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m451.15,444.15h0c0-.97.75-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Z"
              />
              <path
                className="cls-15"
                d="m455.3,442.42h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m422.5,448.31h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m425.72,450.03h0c0-.97.75-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.75,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.44-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m429.86,448.31h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m433.41,450.03h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.46,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m438.3,451.24l.36-.43c.33.29.65.45,1.08.45.37,0,.61-.17.61-.43h0c0-.25-.14-.39-.77-.53-.73-.17-1.14-.4-1.14-1.02h0c0-.6.49-1,1.17-1,.5,0,.89.15,1.24.43l-.32.46c-.31-.23-.62-.35-.93-.35-.35,0-.56.18-.56.41h0c0,.28.16.39.81.55.72.19,1.1.43,1.1,1h0c0,.66-.5,1.03-1.22,1.03-.53,0-1.02-.18-1.43-.55Z"
              />
              <path
                className="cls-15"
                d="m441.5,448.31h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Z"
              />
              <path
                className="cls-15"
                d="m444.61,448.31h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m434.86,431.09c.11-.01.23,0,.34,0,1.82.66,3.59,1.49,5.38,2.23.44.29.46.9.04,1.23-1.66.67-3.32,1.51-4.99,2.13-.27.1-.45.16-.75.12-1.79-.66-3.53-1.47-5.3-2.2-.51-.29-.54-.91-.09-1.27,1.66-.67,3.31-1.49,4.98-2.12.13-.05.25-.1.39-.12Z"
              />
              <path
                className="cls-15"
                d="m438.74,435.9v1.97c0,1-2.05,1.56-2.83,1.67-1.29.18-2.75-.07-3.87-.73-.3-.18-.68-.56-.68-.94v-1.97l3.01,1.26c.44.18.91.18,1.35,0l3.01-1.26Z"
              />
              <path
                className="cls-15"
                d="m439.96,436.19c.43.22.51.75.14,1.06.04.08.12.12.16.2.09.16.1.78.07.97-.02.12-.15.18-.26.2-.16.02-.51.02-.67,0s-.27-.07-.29-.24c-.02-.2-.02-.73.07-.9.04-.09.12-.14.16-.22-.35-.3-.29-.86.14-1.04v-.63s.48-.21.48-.21v.82Z"
              />
            </g>
          </g>
          <g>
            <polygon
              className="cls-15"
              points="364.44 355.37 361.06 355.37 361.06 351.99 358.28 351.99 358.28 355.37 354.89 355.37 354.89 358.16 358.28 358.16 358.28 361.54 361.06 361.54 361.06 358.16 364.44 358.16 364.44 355.37"
            />
            <g>
              <path
                className="cls-15"
                d="m345.97,365.65h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m349.51,365.65h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m352.8,365.65h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m356.67,365.65h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m361.57,365.65h.67l1.03,2.64,1.03-2.64h.65l-1.43,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m365.57,365.65h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m367.09,365.65h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m370.38,365.65h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m348.71,372.09h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m351.05,371.54h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path className="cls-15" d="m354.62,371.54h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m356.14,371.54h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.46-.38l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m359.37,373.51v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m365.82,371.51h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m368.48,371.54h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
            </g>
          </g>
          <g>
            <polygon
              className="cls-15"
              points="262.82 248.88 259.43 248.88 259.43 245.5 256.65 245.5 256.65 248.88 253.27 248.88 253.27 251.66 256.65 251.66 256.65 255.05 259.43 255.05 259.43 251.66 262.82 251.66 262.82 248.88"
            />
            <g>
              <path
                className="cls-15"
                d="m244.34,259.16h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m247.88,259.16h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m251.17,259.16h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m255.04,259.16h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m259.94,259.16h.67l1.03,2.64,1.03-2.64h.65l-1.43,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m263.94,259.16h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m265.46,259.16h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm0,4.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m268.75,259.16h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m242.7,268.21c-.29.21-.64.32-1.04.32-1.05,0-1.79-.8-1.79-1.76h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.4-.12.76-.35,1.06l.39.33-.39.43-.41-.37Zm-.45-.4l-.59-.5.39-.44.59.54c.12-.18.18-.39.18-.64h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23.23,0,.43-.06.59-.17Z"
              />
              <path
                className="cls-15"
                d="m244.13,267.02v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Z"
              />
              <path
                className="cls-15"
                d="m247.75,266.77h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.44-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm1.4-.62l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m251.91,266.77h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m257.99,265.6h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m260.33,265.04h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm1.4-.62l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m264.93,266.77h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path className="cls-15" d="m268.73,265.04h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m271.1,265.6h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m274.44,267.12l-1.36-2.08h.71l.96,1.52.97-1.52h.69l-1.36,2.06v1.37h-.61v-1.35Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m257.77,410.93h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m261.47,410.93h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Z"
              />
              <path
                className="cls-15"
                d="m265.59,409.38v-.17h.7v.17l-.18,2.17h-.33l-.19-2.17Zm.02,2.59h.65v.67h-.65v-.67Z"
              />
              <path
                className="cls-15"
                d="m254.24,415.06h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m256.75,415.09h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m261.8,415.09h.6v2.88h1.8v.55h-2.4v-3.43Z"
              />
              <path
                className="cls-15"
                d="m265.9,415.06h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Zm-.9,1.69h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m268.26,416.81h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m267.45,397.04l-.7,3.82c-.05.16-.15.25-.31.28l-6.23.31.19.74h5.37c.42.09.39.66-.04.7h-5.63c-.18-.04-.25-.12-.31-.28l-1.78-6.68s-.04-.02-.06-.02c-.41-.05-.97.06-1.37,0-.37-.06-.37-.63.02-.69.54.03,1.15-.05,1.68,0,.18.02.27.1.33.26s.27,1.13.33,1.14h8.2c.17,0,.27.12.34.26v.17Zm-6.71.97c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Z"
              />
              <path
                className="cls-15"
                d="m260.72,403.6c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
              <path
                className="cls-15"
                d="m264.92,403.6c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m279.16,243.27h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m281.67,243.3h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Z"
              />
              <path
                className="cls-15"
                d="m284.66,245.02h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Z"
              />
              <path
                className="cls-15"
                d="m288.83,243.3h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m293.88,243.3h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m299.2,243.27h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m301.71,243.3h.6v2.88h1.8v.55h-2.4v-3.43Z"
              />
              <path
                className="cls-15"
                d="m304.6,243.3h.6v2.88h1.8v.55h-2.4v-3.43Z"
              />
              <path
                className="cls-15"
                d="m280.98,249.18h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m283.95,248.34l.54-.24.51.8h-.45l-.6-.56Zm.46.84h.6v3.43h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m285.78,249.18h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m289.51,249.18h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m295.25,249.74h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m298.21,249.16h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm0-1.01h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m300.72,249.18h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m297.72,231.14l-.7,3.82c-.05.16-.15.25-.31.28l-6.23.31.19.74h5.37c.42.09.39.66-.04.7h-5.63c-.18-.04-.25-.12-.31-.28l-1.78-6.68s-.04-.02-.06-.02c-.41-.05-.97.06-1.37,0-.37-.06-.37-.63.02-.69.54.03,1.15-.05,1.68,0,.18.02.27.1.33.26s.27,1.13.33,1.14h8.2c.17,0,.27.12.34.26v.17Zm-6.71.97c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Z"
              />
              <path
                className="cls-15"
                d="m290.99,237.7c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
              <path
                className="cls-15"
                d="m295.18,237.7c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m346.26,213.15h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m349.73,213.15h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Z"
              />
              <path className="cls-15" d="m353.59,214.19h.65v.67h-.65v-.67Z" />
              <path
                className="cls-15"
                d="m354.72,213.15h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Z"
              />
              <path
                className="cls-15"
                d="m358.89,211.43h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m362.02,211.43h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m367.34,211.4h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m369.85,211.43h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m374.08,211.99h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m349.6,217.31h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m352.57,216.47l.54-.24.51.8h-.45l-.6-.56Zm.46.84h.6v3.43h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m354.4,217.31h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m358.13,217.31h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m363.87,217.87h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m366.83,217.29h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm0-1.01h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m369.34,217.31h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m366.34,199.27l-.7,3.82c-.05.16-.15.25-.31.28l-6.23.31.19.74h5.37c.42.09.39.66-.04.7h-5.63c-.18-.04-.25-.12-.31-.28l-1.78-6.68s-.04-.02-.06-.02c-.41-.05-.97.06-1.37,0-.37-.06-.37-.63.02-.69.54.03,1.15-.05,1.68,0,.18.02.27.1.33.26s.27,1.13.33,1.14h8.2c.17,0,.27.12.34.26v.17Zm-6.71.97c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Z"
              />
              <path
                className="cls-15"
                d="m359.61,205.83c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
              <path
                className="cls-15"
                d="m363.8,205.83c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m428,302.98h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m432.11,302.98h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m437.54,302.98h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m441.65,302.98h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Z"
              />
              <path
                className="cls-15"
                d="m444.63,304.7h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m449.7,302.95h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m453.53,302.98h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m458.85,302.95h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm.86,2.09l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m461.36,302.98h1.53c.43,0,.77.13.99.34.18.19.28.44.28.74h0c0,.57-.34.92-.82,1.05l.93,1.3h-.71l-.84-1.2h-.75v1.2h-.6v-3.43Zm1.48,1.7c.43,0,.71-.22.71-.57h0c0-.38-.26-.58-.71-.58h-.88v1.15h.88Z"
              />
              <path
                className="cls-15"
                d="m464.76,302.98h.6v1.72l1.63-1.72h.74l-1.43,1.47,1.49,1.95h-.73l-1.17-1.54-.53.55v.99h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m468.17,302.98h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Z"
              />
              <path
                className="cls-15"
                d="m472.15,303.54h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m439.32,308.86h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m442.29,308.02l.54-.24.51.8h-.45l-.6-.56Zm.46.84h.6v3.43h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m444.12,308.86h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m447.85,308.86h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m452.75,308.86h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m455.87,308.86h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m459.4,310.83v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m456.17,290.82l-.7,3.82c-.05.16-.15.25-.31.28l-6.23.31.19.74h5.37c.42.09.39.66-.04.7h-5.63c-.18-.04-.25-.12-.31-.28l-1.78-6.68s-.04-.02-.06-.02c-.41-.05-.97.06-1.37,0-.37-.06-.37-.63.02-.69.54.03,1.15-.05,1.68,0,.18.02.27.1.33.26s.27,1.13.33,1.14h8.2c.17,0,.27.12.34.26v.17Zm-6.71.97c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Zm2.1,0c-.13.02-.26.16-.28.29.03.47-.05,1.02,0,1.48.04.4.6.43.69.04-.03-.47.06-1.04,0-1.5-.02-.21-.22-.35-.42-.31Z"
              />
              <path
                className="cls-15"
                d="m449.44,297.37c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
              <path
                className="cls-15"
                d="m453.63,297.37c1.3-.11,1.56,1.78.33,2.06-1.47.32-1.78-1.93-.33-2.06Z"
              />
            </g>
          </g>
          <g>
            <text className="cls-33" transform="translate(637.43 244.21)">
              <tspan className="cls-56" x="0" y="0">
                CHỢ BÌNH{' '}
              </tspan>
              <tspan className="cls-55" x="25.82" y="0">
                T
              </tspan>
              <tspan className="cls-44" x="28.4" y="0">
                Â
              </tspan>
              <tspan className="cls-43" x="31.59" y="0">
                Y
              </tspan>
            </text>
            <g>
              <path
                className="cls-15"
                d="m649.85,231.24v-.22c.08-.26.29-.41.54-.47,3.06-.05,6.13-.05,9.19,0,.91.26.58,1.22-.27,1.2h-8.65c-.35-.02-.7-.14-.81-.5Z"
              />
              <path
                className="cls-15"
                d="m659.5,232.13l-.65,4.16c-.1.52-.57.85-1.09.88h-5.58c-.53-.05-.93-.37-1.06-.89l-.66-4.15h9.03Zm-7.12,3.73c.12.11.36.03.38-.14v-2.51c-.03-.25-.41-.28-.44,0v2.51s.04.12.07.14Zm1.39-2.86c-.11,0-.18.1-.19.2-.07.8.06,1.7,0,2.51.03.22.28.27.37.07v-2.66c-.04-.06-.11-.12-.18-.12Zm1.2,0c-.12,0-.18.11-.19.22-.08.76.06,1.67,0,2.45,0,.29.37.32.4.02-.05-.79.07-1.67,0-2.45-.01-.12-.07-.25-.21-.24Zm1.21,0c-.07,0-.13.07-.16.12v2.66c.07.19.38.15.41-.05v-2.57c0-.1-.16-.17-.25-.17Zm1.14.06s-.03.04-.04.07v2.67c.1.16.27.13.36-.02l.02-2.57c-.01-.17-.21-.27-.33-.14Z"
              />
              <path
                className="cls-15"
                d="m658.61,230.08h-1.35l-1.16-2.03c-.33-.69.63-1.31,1.06-.64l1.46,2.67Z"
              />
              <path
                className="cls-15"
                d="m651.35,230.08l1.45-2.66c.46-.68,1.41-.06,1.06.64l-1.16,2.01h-1.35Z"
              />
            </g>
          </g>
          <g>
            <text className="cls-32" transform="translate(793.06 167.46)">
              <tspan x="0" y="0">
                CHỢ AN ĐÔNG
              </tspan>
            </text>
            <g>
              <path
                className="cls-15"
                d="m806.21,154.49v-.22c.08-.26.29-.41.54-.47,3.06-.05,6.13-.05,9.19,0,.91.26.58,1.22-.27,1.2h-8.65c-.35-.02-.7-.14-.81-.5Z"
              />
              <path
                className="cls-15"
                d="m815.86,155.38l-.65,4.16c-.1.52-.57.85-1.09.88h-5.58c-.53-.05-.93-.37-1.06-.89l-.66-4.15h9.03Zm-7.12,3.73c.12.11.36.03.38-.14v-2.51c-.03-.25-.41-.28-.44,0v2.51s.04.12.07.14Zm1.39-2.86c-.11,0-.18.1-.19.2-.07.8.06,1.7,0,2.51.03.22.28.27.37.07v-2.66c-.04-.06-.11-.12-.18-.12Zm1.2,0c-.12,0-.18.11-.19.22-.08.76.06,1.67,0,2.45,0,.29.37.32.4.02-.05-.79.07-1.67,0-2.45-.01-.12-.07-.25-.21-.24Zm1.21,0c-.07,0-.13.07-.16.12v2.66c.07.19.38.15.41-.05v-2.57c0-.1-.16-.17-.25-.17Zm1.14.06s-.03.04-.04.07v2.67c.1.16.27.13.36-.02l.02-2.57c-.01-.17-.21-.27-.33-.14Z"
              />
              <path
                className="cls-15"
                d="m814.98,153.33h-1.35l-1.16-2.03c-.33-.69.63-1.31,1.06-.64l1.46,2.67Z"
              />
              <path
                className="cls-15"
                d="m807.72,153.33l1.45-2.66c.46-.68,1.41-.06,1.06.64l-1.16,2.01h-1.35Z"
              />
            </g>
          </g>
          <g>
            <text className="cls-31" transform="translate(298.17 606.69)">
              <tspan x="0" y="0">
                CHỢ BÌNH ĐIỀN
              </tspan>
            </text>
            <g>
              <path
                className="cls-15"
                d="m312.07,593.72v-.22c.08-.26.29-.41.54-.47,3.06-.05,6.13-.05,9.19,0,.91.26.58,1.22-.27,1.2h-8.65c-.35-.02-.7-.14-.81-.5Z"
              />
              <path
                className="cls-15"
                d="m321.72,594.61l-.65,4.16c-.1.52-.57.85-1.09.88h-5.58c-.53-.05-.93-.37-1.06-.89l-.66-4.15h9.03Zm-7.12,3.73c.12.11.36.03.38-.14v-2.51c-.03-.25-.41-.28-.44,0v2.51s.04.12.07.14Zm1.39-2.86c-.11,0-.18.1-.19.2-.07.8.06,1.7,0,2.51.03.22.28.27.37.07v-2.66c-.04-.06-.11-.12-.18-.12Zm1.2,0c-.12,0-.18.11-.19.22-.08.76.06,1.67,0,2.45,0,.29.37.32.4.02-.05-.79.07-1.67,0-2.45-.01-.12-.07-.25-.21-.24Zm1.21,0c-.07,0-.13.07-.16.12v2.66c.07.19.38.15.41-.05v-2.57c0-.1-.16-.17-.25-.17Zm1.14.06s-.03.04-.04.07v2.67c.1.16.27.13.36-.02l.02-2.57c-.01-.17-.21-.27-.33-.14Z"
              />
              <path
                className="cls-15"
                d="m320.84,592.56h-1.35l-1.16-2.03c-.33-.69.63-1.31,1.06-.64l1.46,2.67Z"
              />
              <path
                className="cls-15"
                d="m313.58,592.56l1.45-2.66c.46-.68,1.41-.06,1.06.64l-1.16,2.01h-1.35Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m352.96,571.76h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m356.35,571.76h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm1.4-.62l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m359.49,571.76h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m364.53,571.76h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m367.66,571.76h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m372.46,571.74h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm-.5-.87l.54-.24.51.8h-.45l-.6-.56Zm1.36,2.96l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m351.89,577.65h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m355.02,577.65h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m358.54,579.62v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m363.63,579.62h-.37v-.54h.37v-1.44h1.28c1.08,0,1.82.74,1.82,1.7h0c0,.97-.75,1.72-1.82,1.72h-1.28v-1.45Zm1.28.91c.72,0,1.19-.48,1.19-1.16h0c0-.68-.47-1.18-1.19-1.18h-.68v.89h.86v.54h-.86v.91h.68Z"
              />
              <path
                className="cls-15"
                d="m367.35,577.65h.6v3.43h-.6v-3.43Zm.03,3.76h.55v.61h-.55v-.61Z"
              />
              <path
                className="cls-15"
                d="m368.73,577.65h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m372.45,577.65h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m367.94,564.48c.08.09.12.23.08.35l-1.45,2.36s-.09.04-.13.05c-.97.23-1.66-.31-2.59-.35-.78-.04-1.16.13-1.86.31-.43.12-.89.13-1.32.01l-1.49-2.4c-.05-.17.04-.33.19-.41l3.86-1.71c.35-.12.55-.08.89.05,1.25.5,2.48,1.16,3.74,1.66.03.03.08.05.11.08Z"
              />
              <path
                className="cls-15"
                d="m360.2,560.32c.04-.46.33-.82.8-.87h1.72s.27-1.47.27-1.47c.05-.09.11-.14.21-.15.17-.02.67-.02.83,0,.18.03.19.24.22.38.09.41.14.83.22,1.24h1.72c.43.03.8.43.8.87v3.09l-.04.02-2.83-1.27c-.35-.11-.71-.11-1.05,0l-2.82,1.26-.04-.02v-3.09Zm2.05.03h-1.22v.87h1.18l.03-.03v-.84Zm1.96,0h-1.24v.84l.03.03h1.17l.03-.03v-.84Zm1.94,0h-1.22v.84l.03.03h1.18v-.87Z"
              />
              <path
                className="cls-15"
                d="m368.18,567.41v.6c-.22,0-.43.02-.64.07-.24.05-.47.16-.71.23-.56.15-1.26.16-1.82.01s-.88-.33-1.51-.31c-.68.02-1.23.37-1.9.41-.87.05-1.18-.17-1.95-.34-.21-.05-.43-.06-.64-.07v-.6c.35-.02.69.04,1.02.14.76.22,1.2.38,2.03.17.72-.19,1.04-.36,1.85-.31.74.05,1.29.43,2.09.41s1.41-.47,2.19-.41Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m382.86,331.65h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m386.4,331.65h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm1.4-.62l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m389.69,331.65h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m396.02,333.33l-1.2-1.69h.71l.85,1.23.86-1.23h.69l-1.19,1.68,1.24,1.75h-.71l-.9-1.3-.91,1.3h-.69l1.25-1.74Z"
              />
              <path
                className="cls-15"
                d="m398.6,331.65h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Z"
              />
              <path
                className="cls-15"
                d="m380.37,337.53h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
              <path className="cls-15" d="m384.66,337.53h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m386.18,337.53h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.46-.38l.54-.24.51.8h-.45l-.6-.56Z"
              />
              <path
                className="cls-15"
                d="m389.46,337.53h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m395.65,338.09h-1.09v-.56h2.78v.56h-1.09v2.87h-.61v-2.87Z"
              />
              <path
                className="cls-15"
                d="m398.75,337.51h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm0-1.01h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m401.88,339.61l-1.36-2.08h.71l.96,1.52.97-1.52h.69l-1.36,2.06v1.37h-.61v-1.35Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m386.42,319.98c.06-.08.12-.14.23-.13.01-.25-.05-.53.1-.74.09-.13.31-.26.47-.26h.54v-1.03c0-.37.57-.87.94-.84h6.39c.35.02.86.5.86.84v1.03h.54c.21,0,.46.18.53.38s.01.44.04.65c.02.06.18,0,.22.14v1.35c-.01.1-.07.15-.17.16-.13.01-.55.02-.68,0s-.15-.13-.16-.24c-.02-.29-.03-.86,0-1.15,0-.06.04-.22.12-.22h.35v-.54s-.12-.18-.16-.18h-.63v5.5s.1.03.15.04c.1.03.18.13.19.24.02.13.02.64,0,.76-.02.08-.14.21-.22.21h-.86v.95c0,.14-.15.25-.29.27-.22.02-.87.03-1.08,0-.09-.01-.25-.15-.25-.24v-.97h-3.48v.97c0,.09-.14.22-.23.24-.19.04-.89.03-1.1,0-.13-.01-.29-.13-.29-.27v-.95h-.86c-.08,0-.2-.12-.22-.21-.02-.11-.02-.66,0-.78.02-.16.18-.25.34-.22v-5.54h-.63s-.16.15-.16.18v.48h.31c.11,0,.15.14.16.22.03.29.03.88,0,1.17-.01.16-.06.23-.22.24-.12.01-.63.01-.71-.03-.04-.02-.05-.07-.09-.09v-1.38Zm7.11-2.31s-.06-.04-.07-.04h-3.16c-.18,0-.16.36-.14.49.01.08.06.12.14.12h3.14c.18.02.13-.52.09-.57Zm-4.78,1.25c-.18.07-.24.18-.25.37-.06.77.05,1.61,0,2.39.02.27.13.37.39.39.79.06,1.65-.05,2.45,0,.15-.01.27-.07.34-.21v-2.75c-.06-.09-.14-.19-.26-.19h-2.67Zm6.37.09c-.07-.07-.14-.09-.24-.09-.84-.06-1.75.05-2.59,0-.14.03-.25.12-.27.27-.08.83.06,1.78,0,2.62.04.19.19.25.37.27.79.06,1.65-.05,2.45,0,.26-.02.35-.14.37-.39.06-.78-.05-1.62,0-2.41,0-.09-.03-.19-.09-.26Zm-5.82,3.68c-.74.11-.75,1.31.04,1.42,1.09.15,1.11-1.6-.04-1.42Zm5.46,1.22c.73-.72-.46-1.75-1.06-.97-.57.73.45,1.58,1.06.97Zm-3.87-1.03c-.16.06-.17.26,0,.31h1.91c.21-.02.17-.31-.02-.32h-1.89Zm1.66.68s-.12-.04-.15-.05c-.25-.02-.84-.03-1.08,0-.21.02-.29.22-.08.32h1.25c.11-.03.15-.19.07-.27Z"
              />
              <path
                className="cls-15"
                d="m393.56,319.41c.14,0,.42-.05.43.15,0,.13-.07.16-.18.18-.36.04-.8-.03-1.17,0-.17-.03-.21-.26-.04-.32.32,0,.64,0,.96-.02Z"
              />
              <path
                className="cls-15"
                d="m394.45,319.41c.34-.06.41.38-.03.31-.17-.03-.17-.28.03-.31Z"
              />
            </g>
          </g>
          <g>
            <text className="cls-33" transform="translate(655.98 380.99)">
              <tspan x="0" y="0">
                BẾN XE Q8
              </tspan>
            </text>
            <g>
              <path
                className="cls-15"
                d="m664.34,365.89c.06-.08.12-.14.23-.13.01-.25-.05-.53.1-.74.09-.13.31-.26.47-.26h.54v-1.03c0-.37.57-.87.94-.84h6.39c.35.02.86.5.86.84v1.03h.54c.21,0,.46.18.53.38s.01.44.04.65c.02.06.18,0,.22.14v1.35c-.01.1-.07.15-.17.16-.13.01-.55.02-.68,0s-.15-.13-.16-.24c-.02-.29-.03-.86,0-1.15,0-.06.04-.22.12-.22h.35v-.54s-.12-.18-.16-.18h-.63v5.5s.1.03.15.04c.1.03.18.13.19.24.02.13.02.64,0,.76-.02.08-.14.21-.22.21h-.86v.95c0,.14-.15.25-.29.27-.22.02-.87.03-1.08,0-.09-.01-.25-.15-.25-.24v-.97h-3.48v.97c0,.09-.14.22-.23.24-.19.04-.89.03-1.1,0-.13-.01-.29-.13-.29-.27v-.95h-.86c-.08,0-.2-.12-.22-.21-.02-.11-.02-.66,0-.78.02-.16.18-.25.34-.22v-5.54h-.63s-.16.15-.16.18v.48h.31c.11,0,.15.14.16.22.03.29.03.88,0,1.17-.01.16-.06.23-.22.24-.12.01-.63.01-.71-.03-.04-.02-.05-.07-.09-.09v-1.38Zm7.11-2.31s-.06-.04-.07-.04h-3.16c-.18,0-.16.36-.14.49.01.08.06.12.14.12h3.14c.18.02.13-.52.09-.57Zm-4.78,1.25c-.18.07-.24.18-.25.37-.06.77.05,1.61,0,2.39.02.27.13.37.39.39.79.06,1.65-.05,2.45,0,.15-.01.27-.07.34-.21v-2.75c-.06-.09-.14-.19-.26-.19h-2.67Zm6.37.09c-.07-.07-.14-.09-.24-.09-.84-.06-1.75.05-2.59,0-.14.03-.25.12-.27.27-.08.83.06,1.78,0,2.62.04.19.19.25.37.27.79.06,1.65-.05,2.45,0,.26-.02.35-.14.37-.39.06-.78-.05-1.62,0-2.41,0-.09-.03-.19-.09-.26Zm-5.82,3.68c-.74.11-.75,1.31.04,1.42,1.09.15,1.11-1.6-.04-1.42Zm5.46,1.22c.73-.72-.46-1.75-1.06-.97-.57.73.45,1.58,1.06.97Zm-3.87-1.03c-.16.06-.17.26,0,.31h1.91c.21-.02.17-.31-.02-.32h-1.89Zm1.66.68s-.12-.04-.15-.05c-.25-.02-.84-.03-1.08,0-.21.02-.29.22-.08.32h1.25c.11-.03.15-.19.07-.27Z"
              />
              <path
                className="cls-15"
                d="m671.47,365.32c.14,0,.42-.05.43.15,0,.13-.07.16-.18.18-.36.04-.8-.03-1.17,0-.17-.03-.21-.26-.04-.32.32,0,.64,0,.96-.02Z"
              />
              <path
                className="cls-15"
                d="m672.37,365.32c.34-.06.41.38-.03.31-.17-.03-.17-.28.03-.31Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m424.99,248.94h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m428.38,248.94h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m432.48,247.22h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m435.98,248.94h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m440.71,247.22h.67l1.03,2.64,1.03-2.64h.65l-1.43,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m444.5,247.22h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m445.79,247.22h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m448.86,247.22h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m427.93,253.1h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m430.98,253.1h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m434.43,255.08v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
              <path
                className="cls-15"
                d="m439.22,253.1h.6v2.88h1.8v.55h-2.4v-3.43Z"
              />
              <path
                className="cls-15"
                d="m443.25,253.08h.56l1.51,3.45h-.64l-.35-.83h-1.62l-.35.83h-.62l1.51-3.45Zm0-1.01h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Zm.86,3.1l-.59-1.37-.59,1.37h1.18Z"
              />
              <path
                className="cls-15"
                d="m445.69,253.1h.64l1.04,1.62,1.04-1.62h.64v3.43h-.6v-2.46l-1.08,1.62h-.02l-1.07-1.61v2.45h-.59v-3.43Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m433.78,238.83v-.52c.07-.63.31-1.22.72-1.71-.22-.89-.08-1.96.53-2.67.84-.98,2.03-.79,2.69.27.44.71.52,1.6.33,2.4,1.08,1.26.93,3.36-.43,4.35-1.69,1.23-3.69-.25-3.83-2.13Z"
              />
              <path
                className="cls-15"
                d="m433.78,243.48s.05-.1.09-.15c.01-.01.14-.08.15-.08h1.64v-1.3c.42.08.82.08,1.24,0v1.3h1.86v-1.3c.42.07.82.08,1.24,0v1.3h1.24v-.62h-.38s-.15-.08-.16-.1c-.1-.12-.1-.31,0-.42.01-.02.15-.09.16-.09h.38v-.98c.04-.15.13-.23.28-.26.62.05,1.32-.06,1.92,0,.15.01.25.1.29.24v1h.39s.15.08.16.1c.1.12.1.31,0,.42-.01.02-.15.09-.16.09h-.38v.62h.38s.14.08.16.09c.17.18.07.44-.15.53h-10.13c-.12-.06-.17-.11-.23-.23v-.17Zm9.34-.85h-1.26v.62h1.26v-.62Z"
              />
              <path
                className="cls-15"
                d="m439.23,233.3c1.57-.16,2.31,2.07,1.91,3.31.83.98.95,2.39.32,3.51s-1.93,1.65-3.09,1.02c0-.02.19-.23.23-.27.89-1.13,1.04-2.67.38-3.95-.05-.09-.26-.41-.27-.45-.01-.06.05-.39.06-.49.04-.73-.16-1.49-.54-2.11.23-.29.63-.52,1.01-.56Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                className="cls-15"
                d="m461.76,273.38h0c0-.98.73-1.78,1.77-1.78.63,0,1.01.22,1.34.53l-.39.45c-.27-.25-.57-.43-.96-.43-.66,0-1.13.54-1.13,1.21h0c0,.68.48,1.23,1.13,1.23.42,0,.69-.17.98-.45l.39.39c-.35.38-.75.61-1.39.61-1,0-1.74-.78-1.74-1.76Z"
              />
              <path
                className="cls-15"
                d="m465.16,273.38h0c0-.97.74-1.78,1.8-1.78s1.79.8,1.79,1.76h0c0,.97-.74,1.78-1.8,1.78s-1.79-.8-1.79-1.76Zm2.95,0h0c0-.68-.48-1.23-1.17-1.23s-1.16.54-1.16,1.21h0c0,.68.48,1.23,1.17,1.23s1.16-.54,1.16-1.21Zm-1.43-2.78h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m469.26,271.66h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m472.75,273.38h0c0-.97.73-1.78,1.77-1.78.59,0,.96.17,1.32.47l-.38.46c-.26-.23-.52-.37-.96-.37-.63,0-1.11.56-1.11,1.21h0c0,.72.47,1.23,1.17,1.23.33,0,.62-.1.83-.26v-.64h-.88v-.52h1.46v1.44c-.34.29-.82.53-1.43.53-1.07,0-1.78-.76-1.78-1.76Z"
              />
              <path
                className="cls-15"
                d="m477.49,271.66h.67l1.03,2.64,1.03-2.64h.65l-1.43,3.45h-.53l-1.43-3.45Z"
              />
              <path className="cls-15" d="m481.27,271.66h.6v3.43h-.6v-3.43Z" />
              <path
                className="cls-15"
                d="m482.57,271.66h2.54v.54h-1.94v.89h1.72v.54h-1.72v.92h1.96v.54h-2.57v-3.43Zm1-1h.55l.57.72h-.47l-.38-.33-.38.33h-.46l.57-.72Z"
              />
              <path
                className="cls-15"
                d="m485.63,271.66h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m464.04,277.54h1.54c.4,0,.7.1.9.3.15.15.23.34.23.57h0c0,.43-.24.64-.49.77.41.14.68.36.68.83h0c0,.62-.5.95-1.27.95h-1.59v-3.43Zm1.42,1.44c.39,0,.65-.15.65-.47h0c0-.28-.21-.45-.6-.45h-.87v.91h.82Zm.18,1.45c.41,0,.66-.16.66-.47h0c0-.3-.23-.47-.71-.47h-.96v.94h1Z"
              />
              <path
                className="cls-15"
                d="m466.94,276.7l.54-.24.51.8h-.45l-.6-.56Zm.46.84h.6v3.43h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m468.7,277.54h.56l1.84,2.37v-2.37h.59v3.43h-.5l-1.89-2.44v2.44h-.59v-3.43Z"
              />
              <path
                className="cls-15"
                d="m472.35,277.54h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m477.1,277.54h1.35c.8,0,1.3.46,1.3,1.15h0c0,.77-.61,1.18-1.37,1.18h-.68v1.1h-.6v-3.43Zm1.3,1.78c.46,0,.74-.25.74-.61h0c0-.42-.29-.62-.74-.62h-.7v1.23h.7Z"
              />
              <path
                className="cls-15"
                d="m480.16,277.54h.6v1.43h1.64v-1.43h.6v3.43h-.6v-1.44h-1.64v1.44h-.6v-3.43Z"
              />
              <path
                className="cls-15"
                d="m483.61,279.52v-1.97h.6v1.95c0,.64.32.98.87.98s.86-.32.86-.96v-1.97h.6v1.94c0,1.02-.58,1.54-1.47,1.54s-1.46-.51-1.46-1.51Zm1.61-3.06l.54.24-.6.56h-.45l.51-.8Z"
              />
            </g>
            <g>
              <path
                className="cls-15"
                d="m470.55,263.28v-.52c.07-.63.31-1.22.72-1.71-.22-.89-.08-1.96.53-2.67.84-.98,2.03-.79,2.69.27.44.71.52,1.6.33,2.4,1.08,1.26.93,3.36-.43,4.35-1.69,1.23-3.69-.25-3.83-2.13Z"
              />
              <path
                className="cls-15"
                d="m470.55,267.93s.05-.1.09-.15c.01-.01.14-.08.15-.08h1.64v-1.3c.42.08.82.08,1.24,0v1.3h1.86v-1.3c.42.07.82.08,1.24,0v1.3h1.24v-.62h-.38s-.15-.08-.16-.1c-.1-.12-.1-.31,0-.42.01-.02.15-.09.16-.09h.38v-.98c.04-.15.13-.23.28-.26.62.05,1.32-.06,1.92,0,.15.01.25.1.29.24v1h.39s.15.08.16.1c.1.12.1.31,0,.42-.01.02-.15.09-.16.09h-.38v.62h.38s.14.08.16.09c.17.18.07.44-.15.53h-10.13c-.12-.06-.17-.11-.23-.23v-.17Zm9.34-.85h-1.26v.62h1.26v-.62Z"
              />
              <path
                className="cls-15"
                d="m476,257.74c1.57-.16,2.31,2.07,1.91,3.31.83.98.95,2.39.32,3.51s-1.93,1.65-3.09,1.02c0-.02.19-.23.23-.27.89-1.13,1.04-2.67.38-3.95-.05-.09-.26-.41-.27-.45-.01-.06.05-.39.06-.49.04-.73-.16-1.49-.54-2.11.23-.29.63-.52,1.01-.56Z"
              />
            </g>
          </g>
        </g>
        <polygon
          className="cls-10"
          points="197.81 668.23 191.44 662.34 197.32 655.97 197.81 668.23"
        />
        <polygon
          className="cls-10"
          points="939.35 384.18 945.43 390.38 939.24 396.45 939.35 384.18"
        />
        <polygon
          className="cls-10"
          points="950.59 162.8 959.07 164.62 957.25 173.1 950.59 162.8"
        />
        <polygon
          className="cls-10"
          points="410.58 502.5 424.35 516.19 409.89 530.87 390.71 517.62 410.58 502.5"
        />
        <polygon
          className="cls-14"
          points="407.53 518.25 482.83 461.37 519.83 501.62 407.53 518.25"
        />
        <g>
          <rect
            className="cls-3"
            x="480.47"
            y="461.16"
            width="111.35"
            height="39.58"
            rx="4.45"
            ry="4.45"
          />
          <g>
            <g className="cls-47">
              <rect
                className="cls-9"
                x="487.99"
                y="463.12"
                width="95.13"
                height="36.17"
                transform="translate(1071.11 962.41) rotate(180)"
              />
            </g>
            <g>
              <g className="cls-39">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-61">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-48">
                <rect
                  className="cls-12"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-64">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-41">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-45">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
              <g className="cls-62">
                <rect
                  className="cls-9"
                  x="487.99"
                  y="463.12"
                  width="95.13"
                  height="36.17"
                  transform="translate(1071.11 962.41) rotate(180)"
                />
              </g>
            </g>
          </g>
        </g>
        <polygon
          className="cls-15"
          points="173.94 198.09 175.42 195.2 178.31 196.68 173.94 198.09"
        />
        <polygon
          className="cls-15"
          points="302.66 196.71 304.32 193.91 307.11 195.57 302.66 196.71"
        />
        <polygon
          className="cls-15"
          points="420.65 179.38 423.01 177.15 425.25 179.51 420.65 179.38"
        />
        <polygon
          className="cls-15"
          points="862.83 166.49 865.65 168.09 864.06 170.92 862.83 166.49"
        />
        <polygon
          className="cls-15"
          points="905.7 240.87 908.34 242.77 906.45 245.41 905.7 240.87"
        />
        <polygon
          className="cls-15"
          points="653.12 671.83 650.88 674.18 648.53 671.94 653.12 671.83"
        />
        <polygon
          className="cls-15"
          points="225.75 693.32 223.28 695.43 221.17 692.96 225.75 693.32"
        />
        <g>
          <text className="cls-46" transform="translate(340.68 90.24)">
            <tspan x="0" y="0">
              THUẬN SỐNG
            </tspan>
          </text>
          <text className="cls-46" transform="translate(403.2 131.56)">
            <tspan x="0" y="0">
              TIỆN BỀ
            </tspan>
          </text>
          <g>
            <path
              className="cls-13"
              d="m582.12,91.27s-.17-.01-.43-.1c-.26-.1-.61-.36-1.04-.79-.51-.65-.71-1.37-.61-2.18.04-.63.24-1.33.61-2.1.37-.82.87-1.64,1.49-2.44.62-.8,1.28-1.49,1.99-2.04.55-.44,1.2-.79,1.93-1.05.73-.26,1.47-.39,2.2-.39.9,0,1.7.2,2.38.59.67.39,1.09.97,1.3,1.78l.11.46h-.25c-.11-.05-.32-.18-.54-.36-.22-.18-.37-.38-.47-.62l-.02-.05-.04-.04c-.32-.32-.79-.48-1.4-.48-.65,0-1.37.17-2.15.51-.77.33-1.38.69-1.81,1.04-2.02,1.63-3.39,3.84-4.05,6.57l-.11.46.46-.13c.7-.2,1.71-.94,3.09-2.24,1.34-1.26,2.77-2.77,4.26-4.49.02,0,.04,0,.06,0,.07,0,.11.01.16.03.19.06.4.21.64.45.38.46.43.72.43.84l-.03.03v.07c-.4.8-.6,1.67-.6,2.59,0,.17.04.49.12.96.05.36.3.57.66.57.41,0,1.24-.23,3.71-2.24,3.16-2.56,3.76-3.02,3.84-3.07.19-.18.34-.25.49-.25.12,0,.22.05.32.15.17.2.26.39.26.55s-.05.22-.09.26c-2.26,1.99-3.93,3.45-4.97,4.31-1.01.85-1.87,1.46-2.54,1.83-.75.39-1.48.6-2.16.6s-1.14-.21-1.51-.65c-.37-.44-.54-1.09-.51-1.93l.03-.69-.5.48c-2.73,2.64-4.08,3.19-4.74,3.19Z"
            />
            <path
              className="cls-13"
              d="m595.71,91.03s-.07,0-.15-.03c-.2-.07-.4-.18-.6-.35-.48-.57-.53-.84-.53-.94l5.18-9.32s.08-.02.11-.02c.03,0,.05,0,.07,0,.2.04.39.16.58.36.38.31.55.62.55.95l-1.46,2.68-.72,1.29,1.14-.95c4.68-3.9,6.56-4.72,7.31-4.72.07,0,.13,0,.18.02h.18c.98.34,1.5.91,1.5,1.74,0,.31-.05.63-.16.94-.08.31-.23.7-.45,1.18-.22.48-.39.82-.5,1l-1.72,3.38.18.14c.2.15.48.23.85.23,1.4,0,3.03-.75,4.85-2.24,2.67-2.18,2.72-2.23,2.74-2.25.1-.14.21-.25.36-.39.12-.11.24-.16.36-.16.04,0,.09.03.15.09.18.18.21.25.21.25-.17.07-.27.17-.32.29-1.36,1.52-2.8,2.89-4.25,4-1.42,1.08-2.62,1.63-3.59,1.63-.37,0-.69-.1-.99-.3-.92-.6-1.37-1.37-1.37-2.35,0-.83.41-2.08,1.23-3.72.32-.63.53-1.09.64-1.4l.25-.68-.64.34c-1.39.73-3.39,2.25-5.96,4.51-2.55,2.25-4.31,3.85-5.23,4.77l-.03.02Z"
            />
            <path
              className="cls-13"
              d="m631.54,91.03s-.07,0-.15-.03c-.2-.07-.4-.18-.6-.35-.48-.57-.53-.84-.53-.93l5.18-9.32s.08-.02.11-.02c.03,0,.05,0,.07,0,.2.04.39.17.58.36.38.31.55.61.55.95l-1.46,2.67-.72,1.29,1.14-.95c4.68-3.9,6.56-4.72,7.32-4.72.07,0,.13,0,.18.02h.18c.98.34,1.5.91,1.5,1.74,0,.31-.05.63-.16.95-.08.31-.23.7-.45,1.17-.22.48-.39.82-.5,1.01l-1.72,3.38.18.14c.2.15.48.23.85.23,1.4,0,3.03-.75,4.85-2.24,2.68-2.19,2.72-2.23,2.74-2.25.1-.14.21-.25.36-.39.12-.11.24-.16.36-.16.04,0,.09.03.15.09.18.18.21.25.21.25-.18.07-.27.18-.32.29-1.36,1.52-2.8,2.89-4.25,4-1.42,1.08-2.62,1.63-3.59,1.63-.37,0-.69-.1-.99-.3-.92-.6-1.37-1.37-1.37-2.35,0-.83.41-2.08,1.23-3.72.31-.61.52-1.08.64-1.4l.26-.68-.64.34c-1.39.73-3.4,2.25-5.96,4.51-2.6,2.29-4.31,3.85-5.23,4.77l-.03.02Z"
            />
            <path
              className="cls-13"
              d="m647.36,92.12s-.07,0-.15-.03c-.19-.06-.38-.19-.58-.39-.38-.31-.55-.62-.55-.95l17.5-28.46s.05-.01.07-.01c.03,0,.06,0,.1.02.21.06.41.19.6.39.38.31.55.62.55.95l-13.32,21.65,1.15-.85c2.12-1.56,3.68-2.35,4.65-2.35.35,0,1.41,0,1.62,2.1.03.24.07,1.16.11,4.22v.08s.05.07.05.07c.06.09.19.21.43.21.23,0,.68-.09,1.94-.84,1.2-.71,2.93-2.12,5.15-4.19.36-.37.5-.38.5-.38.03,0,.09.03.15.09.21.21.32.42.32.61,0,.04-.03.09-.09.15-4.01,3.75-6.82,5.65-8.35,5.65-.39,0-.72-.14-1.01-.44-.41-.45-.68-1.01-.78-1.65-.11-.69-.17-1.59-.17-2.68,0-.77-.02-1.34-.06-1.69-.02-.24-.19-.4-.42-.4-.26,0-.72.18-2.16,1.55-1.38,1.3-2.83,2.77-4.31,4.37-1.47,1.58-2.46,2.67-2.93,3.22h-.01Z"
            />
            <path
              className="cls-13"
              d="m666.84,91.22c-.74,0-1.26-.29-1.59-.89-.24-.45-.37-1-.37-1.64,0-1.09.32-2.25.94-3.42.6-1.17,1.36-2.34,2.24-3.49.88-1.14,1.68-2,2.39-2.56.03-.02.07-.03.12-.03.06,0,.13.02.21.05.2.08.41.24.61.47.32.4.39.66.39.79,0,.11-.02.15-.02.15-.71.61-1.52,1.49-2.42,2.6-.91,1.12-1.66,2.27-2.24,3.43-.45.97-.66,1.65-.66,2.07,0,.73.35,1.01.64,1.12.15.03.24.04.35.04.74,0,1.68-.4,2.88-1.21,1.31-.88,2.61-1.89,3.87-3,1.42-1.24,1.82-1.64,1.94-1.82.29-.28.4-.29.4-.29.09,0,.2.08.26.15.19.19.2.29.2.32h0s0,.06-.15.21c-.04.04-.48.48-1.32,1.32-.83.83-2.18,2-4.02,3.48-1.8,1.44-3.37,2.17-4.67,2.17Zm6.71-14.02s-.08,0-.16-.04c-.21-.08-.42-.22-.62-.43-.43-.51-.49-.78-.49-.89l.05-.1,3.21-3.67s.06-.01.09-.01c.16,0,.38.09.78.44.27.31.42.61.42.88,0,.11-.01.14-.01.14l-3.19,3.63-.08.05Z"
            />
            <path
              className="cls-13"
              d="m678.82,91.5c-.83,0-1.47-.14-1.92-.42-.81-.44-1.46-1.06-1.94-1.86-.49-.79-.73-1.65-.73-2.55,0-.79.21-1.63.63-2.49.43-.87,1-1.73,1.71-2.55,1.16-1.31,2.4-2.44,3.68-3.34.82-.56,1.58-1,2.28-1.32.67-.3,1.02-.37,1.21-.37.05,0,.09,0,.13.01.49.1.88.35,1.23.77.53.6.73,1.2.63,1.84-.04.36-.22.87-.55,1.52-.33.61-.76,1.2-1.29,1.73-.53.53-1.12.97-1.74,1.3-1.12.56-2.29.98-3.49,1.27-1.49.35-2.07.42-2.29.42h-.18l-.07.17c-.44,1-.65,1.77-.65,2.35,0,.91.43,2,2.45,2,1.18,0,2.66-.35,4.4-1.05,1.73-.69,3.34-1.52,4.8-2.46,1.5-.97,2.43-1.8,2.84-2.53.19-.34.38-.37.5-.37.12,0,.22.05.32.15.29.29.32.44.32.49,0,0,0,.06-.09.22-.43.79-1.38,1.77-2.82,2.89-1.45,1.13-3.06,2.12-4.79,2.95-1.71.82-3.25,1.23-4.58,1.23Zm4.99-13.16c-.63.28-1.4.75-2.29,1.41-1.5,1.12-2.7,2.19-3.54,3.2l-.58.68.86-.24c.7-.19,1.58-.53,2.62-.99,1.17-.6,2.17-1.62,2.99-3.04l.6-1.31-.66.29Zm-1.54-4.08c-.1-.03-.21-.1-.33-.21-.15-.15-.24-.3-.26-.44l.02-.05s.36-.34,1.63-1.25c.97-.69,1.87-1.24,2.65-1.61.47-.26.87-.4,1.17-.43.17-.05.28-.07.38-.07.33,0,.6.19.84.57.11.21.13.35.13.43v.23c-.18,1.08-.29,2.01-.34,2.73-.04-.02-.08-.04-.14-.09-.18-.14-.41-.36-.41-.58,0-.54.08-1.26.23-2.19l.08-.5-1.26.54c-.78.39-1.67.93-2.66,1.6-1.25.86-1.59,1.16-1.72,1.31,0,0-.02,0-.03,0Z"
            />
            <path
              className="cls-13"
              d="m687.89,91.03s-.07,0-.15-.03c-.2-.07-.4-.18-.6-.35-.48-.57-.53-.84-.53-.93l5.18-9.32s.08-.02.11-.02c.03,0,.05,0,.07,0,.2.04.39.17.58.36.38.31.55.62.55.95l-1.46,2.67-.72,1.29,1.14-.95c4.68-3.9,6.56-4.72,7.32-4.72.07,0,.13,0,.18.02h.18c.98.34,1.5.91,1.5,1.74,0,.31-.05.63-.16.95-.08.31-.23.7-.45,1.17-.22.48-.39.82-.5,1.01l-1.72,3.38.18.14c.2.15.48.23.85.23,1.4,0,3.03-.75,4.85-2.24,2.67-2.18,2.72-2.23,2.74-2.25.1-.14.21-.25.36-.39.12-.11.24-.16.36-.16.04,0,.09.03.15.09.18.18.21.25.21.25-.18.07-.27.18-.32.29-1.35,1.52-2.8,2.89-4.25,4-1.42,1.08-2.62,1.63-3.59,1.63-.37,0-.69-.1-.99-.3-.92-.6-1.37-1.37-1.37-2.35,0-.83.41-2.08,1.23-3.72.31-.63.53-1.09.64-1.4l.25-.68-.64.34c-1.39.73-3.4,2.25-5.96,4.51-2.55,2.25-4.31,3.85-5.23,4.77l-.02.02Z"
            />
          </g>
          <g>
            <path
              className="cls-13"
              d="m544.3,139.03s-.08,0-.17-.03c-.21-.06-.41-.19-.6-.39-.37-.31-.55-.6-.55-.89l.12-.25,19.84-30.96s.08-.02.11-.02c.03,0,.06,0,.08.01.19.06.41.2.65.41.31.31.48.63.48.94l-12,18.78,1.45-1.26c2.87-2.49,5.61-4.23,8.17-5.17.08,0,.2.03.41.13.22.11.42.29.59.52.2.24.29.46.29.7,0,.08-.03.1-.05.11-2.8,1.05-5.95,3.14-9.32,6.16l-.06.06-.02.08c-.39,1.54-.58,2.96-.58,4.19,0,1.76.44,2.83,1.32,3.18.25.12.58.19.96.19,2.27,0,4.81-1.12,7.54-3.33,4.06-3.28,4.09-3.32,4.12-3.35.51-.51.72-.55.78-.55.08,0,.14.03.21.09.3.3.32.45.32.49,0,.04-.03.09-.09.15-1.29,1.29-3.23,2.94-5.76,4.91-2.5,1.94-4.66,2.92-6.42,2.92-.38,0-.7-.07-.97-.2-2.11-.94-3.17-3.1-3.17-6.4v-.7l-.48.51c-1.26,1.34-2.44,2.68-3.51,4-1.07,1.32-1.92,2.43-2.53,3.28-.62.88-1,1.44-1.16,1.71v-.04Z"
            />
            <path
              className="cls-13"
              d="m570.04,136.63c-.82,0-1.47-.14-1.92-.42-.81-.44-1.46-1.06-1.95-1.86-.49-.79-.73-1.65-.73-2.55,0-.79.21-1.63.63-2.49.43-.87,1-1.73,1.71-2.55,1.16-1.31,2.4-2.44,3.68-3.34.82-.56,1.59-1,2.28-1.32.67-.31,1.02-.37,1.21-.37.05,0,.09,0,.13.01.49.1.89.36,1.23.77.53.6.73,1.2.63,1.84-.04.36-.22.87-.55,1.52-.33.62-.76,1.2-1.29,1.73-.53.53-1.12.97-1.74,1.3-1.11.56-2.29.98-3.49,1.27-1.49.35-2.07.42-2.29.42h-.18l-.07.16c-.44,1-.65,1.77-.65,2.35,0,.91.43,2,2.46,2,1.18,0,2.66-.35,4.4-1.05,1.73-.69,3.35-1.52,4.8-2.46,1.5-.97,2.43-1.8,2.84-2.53.19-.33.38-.37.5-.37.12,0,.22.05.32.15.29.29.32.44.32.49,0,0,0,.06-.08.22-.43.79-1.38,1.77-2.82,2.89-1.45,1.13-3.06,2.12-4.79,2.95-1.71.82-3.25,1.23-4.58,1.23Zm4.99-13.16c-.63.28-1.38.74-2.29,1.41-1.51,1.12-2.7,2.2-3.54,3.2l-.58.68.86-.24c.69-.19,1.57-.52,2.62-.99,1.16-.6,2.17-1.62,2.99-3.04l.6-1.31-.66.29Zm-2.72-2.29c-.11-.03-.22-.1-.33-.21-.15-.15-.24-.3-.26-.44l.02-.05s.36-.34,1.63-1.25c.97-.69,1.87-1.23,2.65-1.61.48-.25.87-.4,1.17-.43.17-.05.28-.07.38-.07.33,0,.6.19.84.57.11.21.13.35.13.43v.23c-.18,1.08-.29,2.01-.34,2.73-.04-.02-.08-.04-.14-.09-.27-.21-.41-.41-.41-.58,0-.54.08-1.26.23-2.19l.08-.49-1.26.54c-.79.39-1.67.93-2.66,1.6-1.25.86-1.59,1.16-1.72,1.31,0,0-.02,0-.03,0Zm8.24-1.33c0-.07.02-.14.15-.22.29-.2.6-.43.97-.7.37-.27.73-.56,1.08-.88.36-.32.67-.63.94-.94.28-.32.49-.61.61-.86l.09-.17v-.06c0-.1.02-.15.15-.2.21-.07.4-.1.6-.1s.36.08.52.24c.19.19.15.27.14.3-.14.38-.43.77-.87,1.16-.47.41-.97.79-1.49,1.12-.53.34-1.06.65-1.58.9-.52.26-.96.45-1.28.56h-.04s0-.14,0-.14Z"
            />
            <path
              className="cls-13"
              d="m580.24,137.72c-.93,0-1.56-.35-1.93-1.06-.09-.18-.14-.41-.14-.67,0-1.02.5-2.63,1.49-4.79,1.03-2.23,4.91-9.17,7.07-12.36l.04-.07v-.08c.02-.57-.17-1.09-.57-1.54.32.23.55.46.7.66l.24.33,2.19-3.5-9.28-.37,1.52.6c.68.27,1.3.53,1.86.78-.33-.1-.69-.19-1.07-.27-2.39-.52-5.27-.78-8.55-.78-.62,0-1.25,0-1.89.03-.06,0-.22-.03-.51-.26-.24-.19-.43-.4-.56-.64-.14-.18-.19-.33-.19-.49l19.6-.07.08-.14c1.03-1.82,1.31-2.14,1.74-2.62.32-.36.72-.81,1.53-1.98,1.93-2.77,3.18-4.56,3.75-5.36.04.01.09.02.18.05.2.06.41.19.6.39.33.33.49.63.49.89l-.92,1.39c-1.49,2.11-2.34,3.14-2.96,3.9-.74.89-1.22,1.49-2.14,3.07l-.24.41h4.38c.07,0,.24.03.53.23.23.17.42.37.55.6.14.18.19.35.19.55l-6.64.07-.08.12c-4.43,6.7-9.4,15.17-10.17,16.64-.79,1.51-1.18,2.58-1.18,3.28,0,.19.04.4.13.66.14.25.37.48.83.48.83,0,2.13-.58,3.99-1.76,1.79-1.14,3.64-2.43,5.49-3.82,1.94-1.46,2.58-1.94,2.79-2.16h0c.08-.06.16-.09.23-.09.15,0,.31.15.42.28.09.09.17.19.17.28s-.07.19-.22.29c-1.48,1.48-3.66,3.34-6.5,5.57-2.8,2.21-5.17,3.32-7.05,3.32Z"
            />
            <path
              className="cls-13"
              d="m609.6,136.16s-.07,0-.15-.03c-.19-.06-.4-.18-.6-.35-.48-.57-.53-.84-.53-.93l5.18-9.32s.08-.02.11-.02c.03,0,.05,0,.07,0,.2.05.39.17.58.36.38.31.55.62.55.95l-1.46,2.67-.72,1.29,1.14-.95c4.68-3.9,6.56-4.72,7.31-4.72.07,0,.13,0,.18.02h.18c.98.34,1.5.91,1.5,1.74,0,.31-.05.63-.16.94-.08.31-.23.7-.45,1.18-.22.48-.39.82-.5,1l-1.72,3.38.18.14c.2.15.48.23.85.23,1.4,0,3.03-.75,4.85-2.24,2.68-2.19,2.72-2.23,2.75-2.26.09-.13.2-.25.36-.39.12-.11.24-.16.36-.16.04,0,.09.03.15.09.18.18.21.25.21.25-.18.07-.27.18-.32.29-1.35,1.52-2.8,2.89-4.25,4-1.41,1.08-2.62,1.63-3.59,1.63-.37,0-.69-.1-.99-.3-.92-.6-1.37-1.37-1.37-2.35,0-.83.41-2.08,1.23-3.72.32-.63.53-1.09.64-1.4l.25-.68-.64.34c-1.39.73-3.39,2.25-5.96,4.51-2.6,2.29-4.31,3.85-5.23,4.77l-.02.02Z"
            />
            <path
              className="cls-13"
              d="m630.28,137.9c-.41,0-.83-.11-1.25-.31-.41-.24-.78-.53-1.06-.85l-.36-.36c-.39-.6-.61-1.43-.61-2.44,0-.81.15-1.73.45-2.73.29-.92.71-1.83,1.23-2.69.52-.85,1.08-1.57,1.67-2.12l.5-.38c.07,0,.14.02.28.07.2.08.41.23.6.47.32.41.39.66.39.79,0,.07-.01.13-.03.15l-.43.32c-1.2,1.07-2.17,2.68-2.9,4.77-.35,1.06-.53,1.99-.53,2.79,0,.45.05.73.16.9l.05.08.09.03c.14.05.32.07.55.07.29,0,.52-.02.7-.07.71-.25,1.32-.64,1.85-1.16.81-.69,1.58-1.74,2.29-3.11.35-.65.66-1.46.94-2.4l.05-.17-.14-.12c-.96-.81-1.69-1.76-2.16-2.82-.44-.95-.62-1.85-.55-2.67.13-.99.59-1.18.92-1.24.03,0,.09,0,.15,0,.36,0,.73.09,1.12.27.69.38,1.25,1,1.64,1.82.3.52.5,1.18.61,1.98.08.45.11.84.11,1.17,0,.21-.04.63-.11,1.23l-.03.25.24.06c.52.12,1.15.18,1.9.18,1.26,0,2.43-.3,3.46-.9.27-.18.37-.19.38-.19,0,0,.09.03.32.26.14.14.21.3.21.49,0,.02,0,.09-.12.18-1.67.91-3.17,1.38-4.42,1.38-.62,0-1.22-.11-1.79-.33l-.29-.11-.07.31c-.26,1.11-.62,2.05-1.06,2.79-.71,1.39-1.48,2.44-2.29,3.14-.76.62-1.39,1.01-1.85,1.15-.18.07-.43.1-.78.1Zm3.9-13.76c-.38.02-.79.3-.79,1.42,0,.49.12,1.03.37,1.6.16.49.48.93.94,1.31l.39.32.06-.5c.08-.63.12-1.09.12-1.41,0-.36-.04-.78-.12-1.25-.03-.34-.08-.66-.17-.94h.29l-.43-.47c-.06-.06-.18-.14-.35-.14-.09,0-.19.02-.3.06Zm2.92-2.53c-.47-.3-.61-.52-.65-.66l-.02-.07-.05-.05c-.1-.38-.23-1.03-.38-1.86l-.02-.14-.46-.23-.11.04c-.68.24-1.43.67-2.28,1.33-.94.72-1.26,1.05-1.38,1.24-.13-.03-.25-.09-.43-.23-.18-.15-.31-.31-.39-.46h0c.02-.06.14-.27,1.06-.93.68-.49,1.36-.93,2.04-1.3.4-.25.74-.39,1.04-.42.16-.05.27-.07.38-.07.34,0,.7.2,1.05.6.21.25.27.4.29.46l.06.23c.1,1.03.22,1.89.36,2.59-.03-.02-.06-.04-.09-.06Zm1.66-4.12s0-.04,0-.07c-.01-.1-.03-.15.09-.22.54-.46,1.15-1.05,1.84-1.8.72-.78,1.17-1.44,1.37-2.02l.02-.21c-.02-.12-.02-.18.12-.23.21-.09.42-.15.63-.18h.03c.23,0,.38.06.53.18.08.06.2.17.17.25-.12.45-.36.87-.75,1.29-.41.45-.87.88-1.35,1.29-.48.41-.98.77-1.48,1.06-.48.28-.86.5-1.16.65h-.06Z"
            />
            <path
              className="cls-13"
              d="m642.21,136.35c-.74,0-1.26-.29-1.59-.89-.24-.45-.37-1.01-.37-1.64,0-1.09.32-2.25.94-3.42.61-1.17,1.36-2.35,2.24-3.49.88-1.14,1.68-2,2.39-2.56.02-.01.05-.03.12-.03.06,0,.13.02.21.05.2.08.41.23.6.47.32.4.39.66.39.79,0,.11-.02.15-.02.15-.71.62-1.52,1.5-2.42,2.6-.91,1.12-1.66,2.27-2.24,3.43-.45.97-.66,1.65-.66,2.07,0,.73.35,1.01.64,1.12.15.03.24.04.35.04.73,0,1.68-.4,2.88-1.21,1.3-.88,2.6-1.89,3.87-3,1.42-1.24,1.82-1.64,1.94-1.82.29-.28.4-.29.4-.29.09,0,.2.08.26.15.19.19.2.29.2.32,0,0,0,.07-.15.21-.04.04-.48.48-1.32,1.32s-2.18,1.99-4.02,3.48c-1.79,1.44-3.37,2.17-4.67,2.17Zm6.71-14.02s-.08,0-.16-.04c-.21-.08-.42-.22-.62-.42-.43-.51-.49-.78-.49-.89h0s.04-.1.04-.1l3.21-3.67s.06-.01.09-.01c.16,0,.38.09.78.44.27.31.42.61.42.88,0,.11-.01.14-.01.14l-3.19,3.63-.08.05Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
